// SPDX-License-Identifier: AGPL-3.0-or-later
// Generated by scripts/GenerateThemeVariables.ts. Do not edit by hand.

export type ThemeVariableKind = 'color' | 'font' | 'dimension' | 'number' | 'shadow' | 'transition' | 'other';

export interface ThemeVariableDefinition {
	name: string;
	kind: ThemeVariableKind;
	groupId: string;
	groupLabel: string;
	source: string;
}

export type ThemeVariableName =
	| "--accent-danger"
	| "--accent-info"
	| "--accent-primary"
	| "--accent-purple"
	| "--accent-success"
	| "--accent-warning"
	| "--active-now-action-gap"
	| "--active-now-action-height"
	| "--active-now-action-padding-block"
	| "--active-now-action-padding-inline"
	| "--active-now-action-radius"
	| "--active-now-card-gap"
	| "--active-now-card-padding-block"
	| "--active-now-card-padding-inline"
	| "--active-now-card-radius"
	| "--active-now-card-shadow"
	| "--active-now-context-gap"
	| "--active-now-sidebar-content-gap"
	| "--active-now-sidebar-content-padding-block-end"
	| "--active-now-sidebar-content-padding-inline"
	| "--active-now-sidebar-header-padding-block-end"
	| "--active-now-sidebar-header-padding-block-start"
	| "--active-now-sidebar-header-padding-inline"
	| "--active-now-sidebar-width"
	| "--alert-caution-color"
	| "--alert-important-color"
	| "--alert-note-color"
	| "--alert-tip-color"
	| "--alert-warning-color"
	| "--ansi-bg-black"
	| "--ansi-bg-blue"
	| "--ansi-bg-bright-black"
	| "--ansi-bg-bright-blue"
	| "--ansi-bg-bright-cyan"
	| "--ansi-bg-bright-green"
	| "--ansi-bg-bright-magenta"
	| "--ansi-bg-bright-red"
	| "--ansi-bg-bright-white"
	| "--ansi-bg-bright-yellow"
	| "--ansi-bg-cyan"
	| "--ansi-bg-green"
	| "--ansi-bg-magenta"
	| "--ansi-bg-red"
	| "--ansi-bg-white"
	| "--ansi-bg-yellow"
	| "--ansi-fg-black"
	| "--ansi-fg-blue"
	| "--ansi-fg-bright-black"
	| "--ansi-fg-bright-blue"
	| "--ansi-fg-bright-cyan"
	| "--ansi-fg-bright-green"
	| "--ansi-fg-bright-magenta"
	| "--ansi-fg-bright-red"
	| "--ansi-fg-bright-white"
	| "--ansi-fg-bright-yellow"
	| "--ansi-fg-cyan"
	| "--ansi-fg-green"
	| "--ansi-fg-magenta"
	| "--ansi-fg-red"
	| "--ansi-fg-white"
	| "--ansi-fg-yellow"
	| "--ansi-inverse-bg"
	| "--ansi-inverse-text"
	| "--avatar-stack-extra-height"
	| "--background-channel-header"
	| "--background-header-primary"
	| "--background-header-primary-hover"
	| "--background-header-secondary"
	| "--background-modifier-accent"
	| "--background-modifier-accent-focus"
	| "--background-modifier-hover"
	| "--background-modifier-selected"
	| "--background-primary"
	| "--background-secondary"
	| "--background-secondary-alt"
	| "--background-secondary-lighter"
	| "--background-tertiary"
	| "--background-textarea"
	| "--bg-active"
	| "--bg-blockquote"
	| "--bg-code"
	| "--bg-code-block"
	| "--bg-hover"
	| "--bg-primary"
	| "--bg-secondary"
	| "--bg-table-header"
	| "--bg-table-row-even"
	| "--bg-table-row-odd"
	| "--bg-tertiary"
	| "--border-color"
	| "--border-color-focus"
	| "--border-color-hover"
	| "--brand-primary"
	| "--brand-primary-fill"
	| "--brand-primary-foreground"
	| "--brand-primary-light"
	| "--brand-primary-light-fill"
	| "--brand-primary-pressed"
	| "--brand-primary-shade"
	| "--brand-secondary"
	| "--brand-tint"
	| "--brand-tint-border"
	| "--brand-tint-hover"
	| "--button-danger-active-fill"
	| "--button-danger-fill"
	| "--button-danger-outline-active-border"
	| "--button-danger-outline-active-fill"
	| "--button-danger-outline-border"
	| "--button-danger-outline-text"
	| "--button-danger-text"
	| "--button-ghost-text"
	| "--button-inverted-fill"
	| "--button-inverted-text"
	| "--button-outline-active-border"
	| "--button-outline-active-fill"
	| "--button-outline-border"
	| "--button-outline-text"
	| "--button-primary-active-fill"
	| "--button-primary-fill"
	| "--button-primary-text"
	| "--button-secondary-active-fill"
	| "--button-secondary-active-text"
	| "--button-secondary-fill"
	| "--button-secondary-text"
	| "--channel-header-action-icon-size"
	| "--channel-header-action-size"
	| "--channel-header-action-size-mobile"
	| "--channel-header-actions-gap"
	| "--channel-header-back-button-gap"
	| "--channel-header-back-button-size"
	| "--channel-header-back-icon-size"
	| "--channel-header-caret-gap"
	| "--channel-header-caret-size"
	| "--channel-header-gap"
	| "--channel-header-icon-size"
	| "--channel-header-name-gap"
	| "--channel-header-name-gap-group-dm"
	| "--channel-header-padding-inline"
	| "--channel-header-topic-divider-gap"
	| "--chat-horizontal-padding"
	| "--chat-horizontal-padding-default"
	| "--chat-mobile-horizontal-padding"
	| "--code-block-bg"
	| "--code-block-border"
	| "--code-block-highlight"
	| "--code-inline-bg"
	| "--code-muted"
	| "--code-text"
	| "--composer-action-gap"
	| "--composer-box-inset"
	| "--composer-box-inset-inline"
	| "--composer-box-padding-inline"
	| "--composer-mobile-box-height"
	| "--composer-mobile-padding-y"
	| "--composer-status-line-height"
	| "--composer-status-row-height"
	| "--composer-status-safe-area"
	| "--composer-status-safe-gap"
	| "--composer-surface-color"
	| "--content-padding"
	| "--content-padding-lg"
	| "--content-padding-sm"
	| "--control-button-active-bg"
	| "--control-button-active-text"
	| "--control-button-danger-hover-bg"
	| "--control-button-danger-text"
	| "--control-button-hover-bg"
	| "--control-button-hover-text"
	| "--control-button-normal-bg"
	| "--control-button-normal-text"
	| "--count-indicator-gap"
	| "--discovery-card-description-min-height"
	| "--dm-sidebar-mobile-header-height"
	| "--emoji-size-emoji"
	| "--emoji-size-jumbo-emoji"
	| "--floating-surface-ring-color"
	| "--floating-surface-ring-color-strong"
	| "--focus-primary"
	| "--folder-radius"
	| "--font-fallback-mono"
	| "--font-fallback-sans"
	| "--font-keybind"
	| "--font-mono"
	| "--font-sans"
	| "--font-sans-primary"
	| "--font-size"
	| "--font-size-xs"
	| "--footer-box-height"
	| "--footer-box-inner-inset"
	| "--footer-box-inset"
	| "--footer-box-inset-inline"
	| "--footer-box-padding-y"
	| "--footer-box-radius"
	| "--footer-row-height"
	| "--form-surface-background"
	| "--friend-row-action-gap"
	| "--friend-row-action-size"
	| "--friend-row-avatar-size"
	| "--friend-row-content-gap"
	| "--friend-row-name-line-height"
	| "--friend-row-padding-block"
	| "--friend-row-padding-inline"
	| "--friend-row-separator-inset"
	| "--friend-row-separator-radius"
	| "--friend-row-subtext-line-height"
	| "--friend-row-subtext-offset"
	| "--guild-badge-surface"
	| "--guild-folder-expanded-surface-size"
	| "--guild-icon-gap"
	| "--guild-icon-size"
	| "--guild-list-divider-base-gap"
	| "--guild-list-divider-line-size"
	| "--guild-list-foreground"
	| "--guild-list-indicator-bar-width"
	| "--guild-list-indicator-inset"
	| "--guild-list-indicator-track-width"
	| "--guild-list-item-box-size"
	| "--guild-list-item-gap"
	| "--guild-list-item-target-half-extra"
	| "--guild-list-item-target-size"
	| "--guild-members-columns"
	| "--guild-members-columns-selectable"
	| "--guild-members-min-width"
	| "--guild-members-min-width-selectable"
	| "--guild-members-select-column-width"
	| "--guild-members-table-row-border-width"
	| "--guild-members-table-row-min-height"
	| "--guilds-layout-item-bg"
	| "--input-container-min-height"
	| "--input-container-padding"
	| "--input-wrapper-padding-bottom"
	| "--input-wrapper-padding-x"
	| "--interactive-active"
	| "--interactive-muted"
	| "--invite-verified-icon-color"
	| "--layout-gap"
	| "--layout-gap-lg"
	| "--layout-gap-sm"
	| "--layout-guild-list-width"
	| "--layout-header-height"
	| "--layout-header-height-mobile"
	| "--layout-header-popout-width"
	| "--layout-member-list-width"
	| "--layout-mobile-bottom-nav-reserved-height"
	| "--layout-sidebar-width"
	| "--layout-user-area-height"
	| "--layout-user-area-reserved-height"
	| "--layout-voice-connection-height"
	| "--link-decoration"
	| "--list-row-min-height"
	| "--macos-traffic-light-inset"
	| "--markup-everyone-border"
	| "--markup-everyone-fill"
	| "--markup-everyone-text"
	| "--markup-here-border"
	| "--markup-here-fill"
	| "--markup-here-text"
	| "--markup-interactive-hover-fill"
	| "--markup-interactive-hover-text"
	| "--markup-jump-link-fill"
	| "--markup-jump-link-hover-fill"
	| "--markup-jump-link-text"
	| "--markup-mention-border"
	| "--markup-mention-fill"
	| "--markup-mention-text"
	| "--markup-restricted-inline-emoji-baseline-shift"
	| "--markup-restricted-inline-emoji-size"
	| "--markup-restricted-inline-icon-baseline-shift"
	| "--markup-strikethrough-color"
	| "--media-border-radius"
	| "--member-list-group-spacer-height"
	| "--member-list-item-content-gap"
	| "--member-list-item-content-height"
	| "--member-list-item-name-line-height"
	| "--member-list-item-padding-block"
	| "--member-list-item-padding-inline"
	| "--member-list-item-status-line-height"
	| "--member-list-row-gap"
	| "--member-list-scroller-padding-block-end"
	| "--member-list-scroller-padding-block-start"
	| "--member-list-scroller-padding-inline"
	| "--mention-badge-medium-size"
	| "--mention-badge-small-size"
	| "--message-action-bar-offset"
	| "--message-avatar-align-offset"
	| "--message-avatar-size"
	| "--message-avatar-size-compact"
	| "--message-compact-container-margin"
	| "--message-compact-gap"
	| "--message-compact-horizontal-padding"
	| "--message-compact-indent"
	| "--message-compact-markdown-alert-padding-block"
	| "--message-compact-markdown-alert-padding-inline"
	| "--message-compact-markdown-block-gap"
	| "--message-compact-markdown-blockquote-divider-margin-end"
	| "--message-compact-markdown-blockquote-gap"
	| "--message-compact-table-max-inline-size"
	| "--message-compact-table-min-cell-width"
	| "--message-compact-text-indent-from-username"
	| "--message-compact-timestamp-width"
	| "--message-compact-username-gap"
	| "--message-container-gap"
	| "--message-container-padding-y"
	| "--message-edited-font-size"
	| "--message-edited-label-font-size"
	| "--message-failed-indicator-font-size"
	| "--message-failed-indicator-gap"
	| "--message-failed-opacity"
	| "--message-filler-padding-bottom"
	| "--message-group-spacing"
	| "--message-gutter"
	| "--message-highlight-bar-width"
	| "--message-icon-size-lg"
	| "--message-icon-size-md"
	| "--message-icon-size-sm"
	| "--message-line-height"
	| "--message-mention-bg"
	| "--message-mention-bg-hover"
	| "--message-mention-color"
	| "--message-mobile-margin"
	| "--message-preview-card-background"
	| "--message-preview-card-border"
	| "--message-preview-card-divider"
	| "--message-replied-username-opacity"
	| "--message-reply-bg"
	| "--message-reply-color"
	| "--message-reply-font-size"
	| "--message-reply-height"
	| "--message-reply-spacing"
	| "--message-reply-spine-radius"
	| "--message-reply-spine-width"
	| "--message-search-bar-height"
	| "--message-search-bar-icon-gap"
	| "--message-search-bar-icon-size"
	| "--message-search-bar-width"
	| "--message-sending-link-opacity"
	| "--message-sending-opacity"
	| "--message-spacing-y"
	| "--message-timestamp-color"
	| "--message-timestamp-compact-font-size"
	| "--message-timestamp-compact-height"
	| "--message-timestamp-font-size"
	| "--message-transition-highlight"
	| "--message-typing-avatar-margin"
	| "--message-typing-gap"
	| "--message-typing-pill-gap"
	| "--message-typing-pill-padding"
	| "--message-typing-text-font-size"
	| "--message-unknown-warning-color"
	| "--messages-bottom-clearance"
	| "--mobile-bottom-nav-height"
	| "--native-titlebar-height"
	| "--outline-frame-border-width"
	| "--outline-frame-radius-native"
	| "--panel-control-bg"
	| "--panel-control-border"
	| "--panel-control-divider"
	| "--panel-control-highlight"
	| "--plutonium"
	| "--plutonium-hover"
	| "--plutonium-icon"
	| "--plutonium-text"
	| "--radius-2xl"
	| "--radius-full"
	| "--radius-lg"
	| "--radius-md"
	| "--radius-sm"
	| "--radius-xl"
	| "--saturation-factor"
	| "--scrollbar-thumb-bg"
	| "--scrollbar-thumb-bg-hover"
	| "--scrollbar-track-bg"
	| "--scroller-spacer-height"
	| "--shadow-lg"
	| "--shadow-md"
	| "--shadow-sm"
	| "--shadow-xl"
	| "--skeleton-chrome-border"
	| "--skeleton-chrome-border-color"
	| "--skeleton-opacity-default"
	| "--skeleton-opacity-muted"
	| "--skeleton-opacity-strong"
	| "--slowmode-indicator-height"
	| "--spacing-0"
	| "--spacing-1"
	| "--spacing-1-5"
	| "--spacing-10"
	| "--spacing-12"
	| "--spacing-16"
	| "--spacing-2"
	| "--spacing-20"
	| "--spacing-24"
	| "--spacing-3"
	| "--spacing-4"
	| "--spacing-5"
	| "--spacing-6"
	| "--spacing-8"
	| "--spoiler-border-radius"
	| "--spoiler-overlay-color"
	| "--spoiler-overlay-hover-color"
	| "--status-danger"
	| "--status-dnd"
	| "--status-idle"
	| "--status-offline"
	| "--status-online"
	| "--status-warning"
	| "--surface-interactive-hover-bg"
	| "--surface-interactive-selected-bg"
	| "--surface-interactive-selected-color"
	| "--system-message-icon-opacity"
	| "--system-message-icon-size"
	| "--text-chat"
	| "--text-chat-muted"
	| "--text-code"
	| "--text-link"
	| "--text-on-brand-primary"
	| "--text-on-brand-primary-light"
	| "--text-on-brand-tint"
	| "--text-on-dark"
	| "--text-primary"
	| "--text-primary-muted"
	| "--text-secondary"
	| "--text-selection"
	| "--text-tertiary"
	| "--text-tertiary-muted"
	| "--text-tertiary-secondary"
	| "--text-warning"
	| "--textarea-button-compact-height"
	| "--textarea-button-compact-icon-size"
	| "--textarea-button-height"
	| "--textarea-button-icon-size"
	| "--textarea-container-padding-x"
	| "--textarea-content-offset"
	| "--textarea-font-size"
	| "--textarea-line-height"
	| "--textarea-min-height"
	| "--textarea-padding-y"
	| "--textarea-side-button-padding"
	| "--textarea-top-bar-height"
	| "--textarea-upload-gap"
	| "--theme-border"
	| "--theme-border-width"
	| "--transition-fast"
	| "--transition-normal"
	| "--transition-slow"
	| "--typing-avatar-size"
	| "--typing-indicator-animation-size"
	| "--typing-indicator-gap"
	| "--typing-indicator-height"
	| "--typing-pill-height"
	| "--user-area-avatar-lead"
	| "--user-area-box-inset-block-end"
	| "--user-area-content-height"
	| "--user-area-divider-color"
	| "--user-area-padding-x"
	| "--user-area-padding-y"
	| "--user-select"
	| "--voice-connection-padding-x"
	| "--voice-connection-padding-y"
	| "--z-index-base"
	| "--z-index-contextmenu"
	| "--z-index-elevated-1"
	| "--z-index-elevated-2"
	| "--z-index-elevated-3"
	| "--z-index-modal"
	| "--z-index-modal-swap"
	| "--z-index-overlay"
	| "--z-index-popout"
	| "--z-index-popout-above-swap"
	| "--z-index-titlebar"
	| "--z-index-toast"
	| "--z-index-tooltip";

export const THEME_VARIABLES: ReadonlyArray<ThemeVariableDefinition> = [
	{name: "--accent-danger", kind: "color", groupId: "brand", groupLabel: "Brand & accents", source: "color-system"},
	{name: "--accent-info", kind: "color", groupId: "brand", groupLabel: "Brand & accents", source: "color-system"},
	{name: "--accent-primary", kind: "color", groupId: "brand", groupLabel: "Brand & accents", source: "color-system"},
	{name: "--accent-purple", kind: "color", groupId: "brand", groupLabel: "Brand & accents", source: "color-system"},
	{name: "--accent-success", kind: "color", groupId: "brand", groupLabel: "Brand & accents", source: "color-system"},
	{name: "--accent-warning", kind: "color", groupId: "brand", groupLabel: "Brand & accents", source: "color-system"},
	{name: "--active-now-action-gap", kind: "dimension", groupId: "layout", groupLabel: "Layout", source: "globals"},
	{name: "--active-now-action-height", kind: "dimension", groupId: "layout", groupLabel: "Layout", source: "globals"},
	{name: "--active-now-action-padding-block", kind: "dimension", groupId: "layout", groupLabel: "Layout", source: "globals"},
	{name: "--active-now-action-padding-inline", kind: "dimension", groupId: "layout", groupLabel: "Layout", source: "globals"},
	{name: "--active-now-action-radius", kind: "dimension", groupId: "borders", groupLabel: "Borders & focus", source: "globals"},
	{name: "--active-now-card-gap", kind: "dimension", groupId: "layout", groupLabel: "Layout", source: "globals"},
	{name: "--active-now-card-padding-block", kind: "dimension", groupId: "layout", groupLabel: "Layout", source: "globals"},
	{name: "--active-now-card-padding-inline", kind: "dimension", groupId: "layout", groupLabel: "Layout", source: "globals"},
	{name: "--active-now-card-radius", kind: "dimension", groupId: "borders", groupLabel: "Borders & focus", source: "globals"},
	{name: "--active-now-card-shadow", kind: "dimension", groupId: "other", groupLabel: "Other", source: "globals"},
	{name: "--active-now-context-gap", kind: "dimension", groupId: "layout", groupLabel: "Layout", source: "globals"},
	{name: "--active-now-sidebar-content-gap", kind: "dimension", groupId: "layout", groupLabel: "Layout", source: "globals"},
	{name: "--active-now-sidebar-content-padding-block-end", kind: "dimension", groupId: "layout", groupLabel: "Layout", source: "globals"},
	{name: "--active-now-sidebar-content-padding-inline", kind: "dimension", groupId: "layout", groupLabel: "Layout", source: "globals"},
	{name: "--active-now-sidebar-header-padding-block-end", kind: "dimension", groupId: "layout", groupLabel: "Layout", source: "globals"},
	{name: "--active-now-sidebar-header-padding-block-start", kind: "dimension", groupId: "layout", groupLabel: "Layout", source: "globals"},
	{name: "--active-now-sidebar-header-padding-inline", kind: "dimension", groupId: "layout", groupLabel: "Layout", source: "globals"},
	{name: "--active-now-sidebar-width", kind: "dimension", groupId: "layout", groupLabel: "Layout", source: "globals"},
	{name: "--alert-caution-color", kind: "color", groupId: "alerts", groupLabel: "Alerts & callouts", source: "color-system"},
	{name: "--alert-important-color", kind: "color", groupId: "alerts", groupLabel: "Alerts & callouts", source: "color-system"},
	{name: "--alert-note-color", kind: "color", groupId: "alerts", groupLabel: "Alerts & callouts", source: "color-system"},
	{name: "--alert-tip-color", kind: "color", groupId: "alerts", groupLabel: "Alerts & callouts", source: "color-system"},
	{name: "--alert-warning-color", kind: "color", groupId: "alerts", groupLabel: "Alerts & callouts", source: "color-system"},
	{name: "--ansi-bg-black", kind: "color", groupId: "code", groupLabel: "Code & terminal", source: "color-system"},
	{name: "--ansi-bg-blue", kind: "color", groupId: "code", groupLabel: "Code & terminal", source: "color-system"},
	{name: "--ansi-bg-bright-black", kind: "color", groupId: "code", groupLabel: "Code & terminal", source: "color-system"},
	{name: "--ansi-bg-bright-blue", kind: "color", groupId: "code", groupLabel: "Code & terminal", source: "color-system"},
	{name: "--ansi-bg-bright-cyan", kind: "color", groupId: "code", groupLabel: "Code & terminal", source: "color-system"},
	{name: "--ansi-bg-bright-green", kind: "color", groupId: "code", groupLabel: "Code & terminal", source: "color-system"},
	{name: "--ansi-bg-bright-magenta", kind: "color", groupId: "code", groupLabel: "Code & terminal", source: "color-system"},
	{name: "--ansi-bg-bright-red", kind: "color", groupId: "code", groupLabel: "Code & terminal", source: "color-system"},
	{name: "--ansi-bg-bright-white", kind: "color", groupId: "code", groupLabel: "Code & terminal", source: "color-system"},
	{name: "--ansi-bg-bright-yellow", kind: "color", groupId: "code", groupLabel: "Code & terminal", source: "color-system"},
	{name: "--ansi-bg-cyan", kind: "color", groupId: "code", groupLabel: "Code & terminal", source: "color-system"},
	{name: "--ansi-bg-green", kind: "color", groupId: "code", groupLabel: "Code & terminal", source: "color-system"},
	{name: "--ansi-bg-magenta", kind: "color", groupId: "code", groupLabel: "Code & terminal", source: "color-system"},
	{name: "--ansi-bg-red", kind: "color", groupId: "code", groupLabel: "Code & terminal", source: "color-system"},
	{name: "--ansi-bg-white", kind: "color", groupId: "code", groupLabel: "Code & terminal", source: "color-system"},
	{name: "--ansi-bg-yellow", kind: "color", groupId: "code", groupLabel: "Code & terminal", source: "color-system"},
	{name: "--ansi-fg-black", kind: "color", groupId: "code", groupLabel: "Code & terminal", source: "color-system"},
	{name: "--ansi-fg-blue", kind: "color", groupId: "code", groupLabel: "Code & terminal", source: "color-system"},
	{name: "--ansi-fg-bright-black", kind: "color", groupId: "code", groupLabel: "Code & terminal", source: "color-system"},
	{name: "--ansi-fg-bright-blue", kind: "color", groupId: "code", groupLabel: "Code & terminal", source: "color-system"},
	{name: "--ansi-fg-bright-cyan", kind: "color", groupId: "code", groupLabel: "Code & terminal", source: "color-system"},
	{name: "--ansi-fg-bright-green", kind: "color", groupId: "code", groupLabel: "Code & terminal", source: "color-system"},
	{name: "--ansi-fg-bright-magenta", kind: "color", groupId: "code", groupLabel: "Code & terminal", source: "color-system"},
	{name: "--ansi-fg-bright-red", kind: "color", groupId: "code", groupLabel: "Code & terminal", source: "color-system"},
	{name: "--ansi-fg-bright-white", kind: "color", groupId: "code", groupLabel: "Code & terminal", source: "color-system"},
	{name: "--ansi-fg-bright-yellow", kind: "color", groupId: "code", groupLabel: "Code & terminal", source: "color-system"},
	{name: "--ansi-fg-cyan", kind: "color", groupId: "code", groupLabel: "Code & terminal", source: "color-system"},
	{name: "--ansi-fg-green", kind: "color", groupId: "code", groupLabel: "Code & terminal", source: "color-system"},
	{name: "--ansi-fg-magenta", kind: "color", groupId: "code", groupLabel: "Code & terminal", source: "color-system"},
	{name: "--ansi-fg-red", kind: "color", groupId: "code", groupLabel: "Code & terminal", source: "color-system"},
	{name: "--ansi-fg-white", kind: "color", groupId: "code", groupLabel: "Code & terminal", source: "color-system"},
	{name: "--ansi-fg-yellow", kind: "color", groupId: "code", groupLabel: "Code & terminal", source: "color-system"},
	{name: "--ansi-inverse-bg", kind: "color", groupId: "code", groupLabel: "Code & terminal", source: "color-system"},
	{name: "--ansi-inverse-text", kind: "color", groupId: "code", groupLabel: "Code & terminal", source: "color-system"},
	{name: "--avatar-stack-extra-height", kind: "dimension", groupId: "layout", groupLabel: "Layout", source: "globals"},
	{name: "--background-channel-header", kind: "color", groupId: "surfaces", groupLabel: "Surfaces", source: "color-system"},
	{name: "--background-header-primary", kind: "color", groupId: "surfaces", groupLabel: "Surfaces", source: "color-system"},
	{name: "--background-header-primary-hover", kind: "color", groupId: "surfaces", groupLabel: "Surfaces", source: "color-system"},
	{name: "--background-header-secondary", kind: "color", groupId: "surfaces", groupLabel: "Surfaces", source: "color-system"},
	{name: "--background-modifier-accent", kind: "color", groupId: "surfaces", groupLabel: "Surfaces", source: "color-system"},
	{name: "--background-modifier-accent-focus", kind: "color", groupId: "borders", groupLabel: "Borders & focus", source: "color-system"},
	{name: "--background-modifier-hover", kind: "color", groupId: "surfaces", groupLabel: "Surfaces", source: "color-system"},
	{name: "--background-modifier-selected", kind: "color", groupId: "surfaces", groupLabel: "Surfaces", source: "color-system"},
	{name: "--background-primary", kind: "color", groupId: "surfaces", groupLabel: "Surfaces", source: "color-system"},
	{name: "--background-secondary", kind: "color", groupId: "surfaces", groupLabel: "Surfaces", source: "color-system"},
	{name: "--background-secondary-alt", kind: "color", groupId: "surfaces", groupLabel: "Surfaces", source: "color-system"},
	{name: "--background-secondary-lighter", kind: "color", groupId: "surfaces", groupLabel: "Surfaces", source: "color-system"},
	{name: "--background-tertiary", kind: "color", groupId: "surfaces", groupLabel: "Surfaces", source: "color-system"},
	{name: "--background-textarea", kind: "color", groupId: "forms", groupLabel: "Forms", source: "color-system"},
	{name: "--bg-active", kind: "color", groupId: "surfaces", groupLabel: "Surfaces", source: "color-system"},
	{name: "--bg-blockquote", kind: "color", groupId: "surfaces", groupLabel: "Surfaces", source: "color-system"},
	{name: "--bg-code", kind: "color", groupId: "surfaces", groupLabel: "Surfaces", source: "color-system"},
	{name: "--bg-code-block", kind: "color", groupId: "surfaces", groupLabel: "Surfaces", source: "color-system"},
	{name: "--bg-hover", kind: "color", groupId: "surfaces", groupLabel: "Surfaces", source: "color-system"},
	{name: "--bg-primary", kind: "color", groupId: "surfaces", groupLabel: "Surfaces", source: "color-system"},
	{name: "--bg-secondary", kind: "color", groupId: "surfaces", groupLabel: "Surfaces", source: "color-system"},
	{name: "--bg-table-header", kind: "color", groupId: "tables", groupLabel: "Tables", source: "color-system"},
	{name: "--bg-table-row-even", kind: "color", groupId: "tables", groupLabel: "Tables", source: "color-system"},
	{name: "--bg-table-row-odd", kind: "color", groupId: "tables", groupLabel: "Tables", source: "color-system"},
	{name: "--bg-tertiary", kind: "color", groupId: "surfaces", groupLabel: "Surfaces", source: "color-system"},
	{name: "--border-color", kind: "color", groupId: "borders", groupLabel: "Borders & focus", source: "color-system"},
	{name: "--border-color-focus", kind: "color", groupId: "borders", groupLabel: "Borders & focus", source: "color-system"},
	{name: "--border-color-hover", kind: "color", groupId: "borders", groupLabel: "Borders & focus", source: "color-system"},
	{name: "--brand-primary", kind: "color", groupId: "brand", groupLabel: "Brand & accents", source: "color-system"},
	{name: "--brand-primary-fill", kind: "color", groupId: "brand", groupLabel: "Brand & accents", source: "color-system"},
	{name: "--brand-primary-foreground", kind: "color", groupId: "brand", groupLabel: "Brand & accents", source: "color-system"},
	{name: "--brand-primary-light", kind: "color", groupId: "brand", groupLabel: "Brand & accents", source: "color-system"},
	{name: "--brand-primary-light-fill", kind: "color", groupId: "brand", groupLabel: "Brand & accents", source: "color-system"},
	{name: "--brand-primary-pressed", kind: "color", groupId: "brand", groupLabel: "Brand & accents", source: "color-system"},
	{name: "--brand-primary-shade", kind: "color", groupId: "brand", groupLabel: "Brand & accents", source: "color-system"},
	{name: "--brand-secondary", kind: "color", groupId: "brand", groupLabel: "Brand & accents", source: "color-system"},
	{name: "--brand-tint", kind: "color", groupId: "brand", groupLabel: "Brand & accents", source: "color-system"},
	{name: "--brand-tint-border", kind: "color", groupId: "brand", groupLabel: "Brand & accents", source: "color-system"},
	{name: "--brand-tint-hover", kind: "color", groupId: "brand", groupLabel: "Brand & accents", source: "color-system"},
	{name: "--button-danger-active-fill", kind: "color", groupId: "buttons", groupLabel: "Buttons", source: "color-system"},
	{name: "--button-danger-fill", kind: "color", groupId: "buttons", groupLabel: "Buttons", source: "color-system"},
	{name: "--button-danger-outline-active-border", kind: "color", groupId: "buttons", groupLabel: "Buttons", source: "color-system"},
	{name: "--button-danger-outline-active-fill", kind: "color", groupId: "buttons", groupLabel: "Buttons", source: "color-system"},
	{name: "--button-danger-outline-border", kind: "other", groupId: "buttons", groupLabel: "Buttons", source: "color-system"},
	{name: "--button-danger-outline-text", kind: "color", groupId: "buttons", groupLabel: "Buttons", source: "color-system"},
	{name: "--button-danger-text", kind: "color", groupId: "buttons", groupLabel: "Buttons", source: "color-system"},
	{name: "--button-ghost-text", kind: "color", groupId: "buttons", groupLabel: "Buttons", source: "color-system"},
	{name: "--button-inverted-fill", kind: "color", groupId: "buttons", groupLabel: "Buttons", source: "color-system"},
	{name: "--button-inverted-text", kind: "color", groupId: "buttons", groupLabel: "Buttons", source: "color-system"},
	{name: "--button-outline-active-border", kind: "other", groupId: "buttons", groupLabel: "Buttons", source: "color-system"},
	{name: "--button-outline-active-fill", kind: "color", groupId: "buttons", groupLabel: "Buttons", source: "color-system"},
	{name: "--button-outline-border", kind: "other", groupId: "buttons", groupLabel: "Buttons", source: "color-system"},
	{name: "--button-outline-text", kind: "color", groupId: "buttons", groupLabel: "Buttons", source: "color-system"},
	{name: "--button-primary-active-fill", kind: "color", groupId: "buttons", groupLabel: "Buttons", source: "color-system"},
	{name: "--button-primary-fill", kind: "color", groupId: "buttons", groupLabel: "Buttons", source: "color-system"},
	{name: "--button-primary-text", kind: "color", groupId: "buttons", groupLabel: "Buttons", source: "color-system"},
	{name: "--button-secondary-active-fill", kind: "color", groupId: "buttons", groupLabel: "Buttons", source: "color-system"},
	{name: "--button-secondary-active-text", kind: "color", groupId: "buttons", groupLabel: "Buttons", source: "color-system"},
	{name: "--button-secondary-fill", kind: "color", groupId: "buttons", groupLabel: "Buttons", source: "color-system"},
	{name: "--button-secondary-text", kind: "color", groupId: "buttons", groupLabel: "Buttons", source: "color-system"},
	{name: "--channel-header-action-icon-size", kind: "dimension", groupId: "layout", groupLabel: "Layout", source: "globals"},
	{name: "--channel-header-action-size", kind: "dimension", groupId: "layout", groupLabel: "Layout", source: "globals"},
	{name: "--channel-header-action-size-mobile", kind: "dimension", groupId: "layout", groupLabel: "Layout", source: "globals"},
	{name: "--channel-header-actions-gap", kind: "dimension", groupId: "layout", groupLabel: "Layout", source: "globals"},
	{name: "--channel-header-back-button-gap", kind: "dimension", groupId: "buttons", groupLabel: "Buttons", source: "globals"},
	{name: "--channel-header-back-button-size", kind: "dimension", groupId: "buttons", groupLabel: "Buttons", source: "globals"},
	{name: "--channel-header-back-icon-size", kind: "dimension", groupId: "layout", groupLabel: "Layout", source: "globals"},
	{name: "--channel-header-caret-gap", kind: "dimension", groupId: "layout", groupLabel: "Layout", source: "globals"},
	{name: "--channel-header-caret-size", kind: "dimension", groupId: "layout", groupLabel: "Layout", source: "globals"},
	{name: "--channel-header-gap", kind: "dimension", groupId: "layout", groupLabel: "Layout", source: "globals"},
	{name: "--channel-header-icon-size", kind: "dimension", groupId: "layout", groupLabel: "Layout", source: "globals"},
	{name: "--channel-header-name-gap", kind: "dimension", groupId: "layout", groupLabel: "Layout", source: "globals"},
	{name: "--channel-header-name-gap-group-dm", kind: "dimension", groupId: "layout", groupLabel: "Layout", source: "globals"},
	{name: "--channel-header-padding-inline", kind: "dimension", groupId: "layout", groupLabel: "Layout", source: "globals"},
	{name: "--channel-header-topic-divider-gap", kind: "dimension", groupId: "layout", groupLabel: "Layout", source: "globals"},
	{name: "--chat-horizontal-padding", kind: "dimension", groupId: "layout", groupLabel: "Layout", source: "runtime-accessibility"},
	{name: "--chat-horizontal-padding-default", kind: "dimension", groupId: "layout", groupLabel: "Layout", source: "globals"},
	{name: "--chat-mobile-horizontal-padding", kind: "dimension", groupId: "layout", groupLabel: "Layout", source: "globals"},
	{name: "--code-block-bg", kind: "color", groupId: "code", groupLabel: "Code & terminal", source: "color-system"},
	{name: "--code-block-border", kind: "color", groupId: "code", groupLabel: "Code & terminal", source: "color-system"},
	{name: "--code-block-highlight", kind: "color", groupId: "code", groupLabel: "Code & terminal", source: "color-system"},
	{name: "--code-inline-bg", kind: "color", groupId: "code", groupLabel: "Code & terminal", source: "color-system"},
	{name: "--code-muted", kind: "color", groupId: "code", groupLabel: "Code & terminal", source: "color-system"},
	{name: "--code-text", kind: "color", groupId: "code", groupLabel: "Code & terminal", source: "color-system"},
	{name: "--composer-action-gap", kind: "dimension", groupId: "layout", groupLabel: "Layout", source: "globals"},
	{name: "--composer-box-inset", kind: "dimension", groupId: "other", groupLabel: "Other", source: "globals"},
	{name: "--composer-box-inset-inline", kind: "dimension", groupId: "other", groupLabel: "Other", source: "globals"},
	{name: "--composer-box-padding-inline", kind: "dimension", groupId: "layout", groupLabel: "Layout", source: "globals"},
	{name: "--composer-mobile-box-height", kind: "dimension", groupId: "layout", groupLabel: "Layout", source: "globals"},
	{name: "--composer-mobile-padding-y", kind: "dimension", groupId: "layout", groupLabel: "Layout", source: "globals"},
	{name: "--composer-status-line-height", kind: "dimension", groupId: "layout", groupLabel: "Layout", source: "globals"},
	{name: "--composer-status-row-height", kind: "dimension", groupId: "layout", groupLabel: "Layout", source: "globals"},
	{name: "--composer-status-safe-area", kind: "dimension", groupId: "other", groupLabel: "Other", source: "globals"},
	{name: "--composer-status-safe-gap", kind: "dimension", groupId: "layout", groupLabel: "Layout", source: "globals"},
	{name: "--composer-surface-color", kind: "color", groupId: "surfaces", groupLabel: "Surfaces", source: "globals"},
	{name: "--content-padding", kind: "dimension", groupId: "layout", groupLabel: "Layout", source: "globals"},
	{name: "--content-padding-lg", kind: "dimension", groupId: "layout", groupLabel: "Layout", source: "globals"},
	{name: "--content-padding-sm", kind: "dimension", groupId: "layout", groupLabel: "Layout", source: "globals"},
	{name: "--control-button-active-bg", kind: "color", groupId: "buttons", groupLabel: "Buttons", source: "color-system"},
	{name: "--control-button-active-text", kind: "color", groupId: "buttons", groupLabel: "Buttons", source: "color-system"},
	{name: "--control-button-danger-hover-bg", kind: "color", groupId: "buttons", groupLabel: "Buttons", source: "color-system"},
	{name: "--control-button-danger-text", kind: "color", groupId: "buttons", groupLabel: "Buttons", source: "color-system"},
	{name: "--control-button-hover-bg", kind: "color", groupId: "buttons", groupLabel: "Buttons", source: "color-system"},
	{name: "--control-button-hover-text", kind: "color", groupId: "buttons", groupLabel: "Buttons", source: "color-system"},
	{name: "--control-button-normal-bg", kind: "color", groupId: "buttons", groupLabel: "Buttons", source: "color-system"},
	{name: "--control-button-normal-text", kind: "color", groupId: "buttons", groupLabel: "Buttons", source: "color-system"},
	{name: "--count-indicator-gap", kind: "dimension", groupId: "layout", groupLabel: "Layout", source: "globals"},
	{name: "--discovery-card-description-min-height", kind: "dimension", groupId: "layout", groupLabel: "Layout", source: "globals"},
	{name: "--dm-sidebar-mobile-header-height", kind: "dimension", groupId: "layout", groupLabel: "Layout", source: "globals"},
	{name: "--emoji-size-emoji", kind: "dimension", groupId: "emoji", groupLabel: "Emoji", source: "globals"},
	{name: "--emoji-size-jumbo-emoji", kind: "dimension", groupId: "emoji", groupLabel: "Emoji", source: "globals"},
	{name: "--floating-surface-ring-color", kind: "color", groupId: "surfaces", groupLabel: "Surfaces", source: "globals"},
	{name: "--floating-surface-ring-color-strong", kind: "color", groupId: "surfaces", groupLabel: "Surfaces", source: "globals"},
	{name: "--focus-primary", kind: "color", groupId: "borders", groupLabel: "Borders & focus", source: "globals"},
	{name: "--folder-radius", kind: "dimension", groupId: "borders", groupLabel: "Borders & focus", source: "globals"},
	{name: "--font-fallback-mono", kind: "other", groupId: "typography", groupLabel: "Typography", source: "app/font-fallback.css"},
	{name: "--font-fallback-sans", kind: "other", groupId: "typography", groupLabel: "Typography", source: "app/font-fallback.css"},
	{name: "--font-keybind", kind: "other", groupId: "typography", groupLabel: "Typography", source: "globals"},
	{name: "--font-mono", kind: "font", groupId: "typography", groupLabel: "Typography", source: "app/font-fallback.css"},
	{name: "--font-sans", kind: "font", groupId: "typography", groupLabel: "Typography", source: "app/font-fallback.css"},
	{name: "--font-sans-primary", kind: "other", groupId: "typography", groupLabel: "Typography", source: "app/font-fallback.css"},
	{name: "--font-size", kind: "dimension", groupId: "typography", groupLabel: "Typography", source: "runtime-accessibility"},
	{name: "--font-size-xs", kind: "dimension", groupId: "typography", groupLabel: "Typography", source: "globals"},
	{name: "--footer-box-height", kind: "dimension", groupId: "layout", groupLabel: "Layout", source: "globals"},
	{name: "--footer-box-inner-inset", kind: "dimension", groupId: "other", groupLabel: "Other", source: "globals"},
	{name: "--footer-box-inset", kind: "dimension", groupId: "other", groupLabel: "Other", source: "globals"},
	{name: "--footer-box-inset-inline", kind: "dimension", groupId: "other", groupLabel: "Other", source: "globals"},
	{name: "--footer-box-padding-y", kind: "dimension", groupId: "layout", groupLabel: "Layout", source: "globals"},
	{name: "--footer-box-radius", kind: "dimension", groupId: "borders", groupLabel: "Borders & focus", source: "globals"},
	{name: "--footer-row-height", kind: "dimension", groupId: "layout", groupLabel: "Layout", source: "globals"},
	{name: "--form-surface-background", kind: "color", groupId: "forms", groupLabel: "Forms", source: "globals"},
	{name: "--friend-row-action-gap", kind: "dimension", groupId: "layout", groupLabel: "Layout", source: "globals"},
	{name: "--friend-row-action-size", kind: "dimension", groupId: "layout", groupLabel: "Layout", source: "globals"},
	{name: "--friend-row-avatar-size", kind: "dimension", groupId: "layout", groupLabel: "Layout", source: "globals"},
	{name: "--friend-row-content-gap", kind: "dimension", groupId: "layout", groupLabel: "Layout", source: "globals"},
	{name: "--friend-row-name-line-height", kind: "dimension", groupId: "layout", groupLabel: "Layout", source: "globals"},
	{name: "--friend-row-padding-block", kind: "dimension", groupId: "layout", groupLabel: "Layout", source: "globals"},
	{name: "--friend-row-padding-inline", kind: "dimension", groupId: "layout", groupLabel: "Layout", source: "globals"},
	{name: "--friend-row-separator-inset", kind: "dimension", groupId: "other", groupLabel: "Other", source: "globals"},
	{name: "--friend-row-separator-radius", kind: "dimension", groupId: "borders", groupLabel: "Borders & focus", source: "globals"},
	{name: "--friend-row-subtext-line-height", kind: "dimension", groupId: "layout", groupLabel: "Layout", source: "globals"},
	{name: "--friend-row-subtext-offset", kind: "dimension", groupId: "other", groupLabel: "Other", source: "globals"},
	{name: "--guild-badge-surface", kind: "color", groupId: "surfaces", groupLabel: "Surfaces", source: "globals"},
	{name: "--guild-folder-expanded-surface-size", kind: "dimension", groupId: "layout", groupLabel: "Layout", source: "globals"},
	{name: "--guild-icon-gap", kind: "dimension", groupId: "layout", groupLabel: "Layout", source: "globals"},
	{name: "--guild-icon-size", kind: "dimension", groupId: "layout", groupLabel: "Layout", source: "globals"},
	{name: "--guild-list-divider-base-gap", kind: "dimension", groupId: "layout", groupLabel: "Layout", source: "globals"},
	{name: "--guild-list-divider-line-size", kind: "dimension", groupId: "layout", groupLabel: "Layout", source: "globals"},
	{name: "--guild-list-foreground", kind: "color", groupId: "surfaces", groupLabel: "Surfaces", source: "color-system"},
	{name: "--guild-list-indicator-bar-width", kind: "dimension", groupId: "layout", groupLabel: "Layout", source: "globals"},
	{name: "--guild-list-indicator-inset", kind: "dimension", groupId: "surfaces", groupLabel: "Surfaces", source: "globals"},
	{name: "--guild-list-indicator-track-width", kind: "dimension", groupId: "layout", groupLabel: "Layout", source: "globals"},
	{name: "--guild-list-item-box-size", kind: "dimension", groupId: "layout", groupLabel: "Layout", source: "globals"},
	{name: "--guild-list-item-gap", kind: "dimension", groupId: "layout", groupLabel: "Layout", source: "globals"},
	{name: "--guild-list-item-target-half-extra", kind: "dimension", groupId: "surfaces", groupLabel: "Surfaces", source: "globals"},
	{name: "--guild-list-item-target-size", kind: "dimension", groupId: "layout", groupLabel: "Layout", source: "globals"},
	{name: "--guild-members-columns", kind: "dimension", groupId: "other", groupLabel: "Other", source: "globals"},
	{name: "--guild-members-columns-selectable", kind: "dimension", groupId: "tables", groupLabel: "Tables", source: "globals"},
	{name: "--guild-members-min-width", kind: "dimension", groupId: "layout", groupLabel: "Layout", source: "globals"},
	{name: "--guild-members-min-width-selectable", kind: "dimension", groupId: "tables", groupLabel: "Tables", source: "globals"},
	{name: "--guild-members-select-column-width", kind: "dimension", groupId: "layout", groupLabel: "Layout", source: "globals"},
	{name: "--guild-members-table-row-border-width", kind: "dimension", groupId: "tables", groupLabel: "Tables", source: "globals"},
	{name: "--guild-members-table-row-min-height", kind: "dimension", groupId: "tables", groupLabel: "Tables", source: "globals"},
	{name: "--guilds-layout-item-bg", kind: "color", groupId: "layout", groupLabel: "Layout", source: "globals"},
	{name: "--input-container-min-height", kind: "dimension", groupId: "forms", groupLabel: "Forms", source: "globals"},
	{name: "--input-container-padding", kind: "dimension", groupId: "forms", groupLabel: "Forms", source: "globals"},
	{name: "--input-wrapper-padding-bottom", kind: "dimension", groupId: "forms", groupLabel: "Forms", source: "globals"},
	{name: "--input-wrapper-padding-x", kind: "dimension", groupId: "forms", groupLabel: "Forms", source: "globals"},
	{name: "--interactive-active", kind: "color", groupId: "other", groupLabel: "Other", source: "color-system"},
	{name: "--interactive-muted", kind: "color", groupId: "other", groupLabel: "Other", source: "color-system"},
	{name: "--invite-verified-icon-color", kind: "color", groupId: "other", groupLabel: "Other", source: "color-system"},
	{name: "--layout-gap", kind: "dimension", groupId: "layout", groupLabel: "Layout", source: "globals"},
	{name: "--layout-gap-lg", kind: "dimension", groupId: "layout", groupLabel: "Layout", source: "globals"},
	{name: "--layout-gap-sm", kind: "dimension", groupId: "layout", groupLabel: "Layout", source: "globals"},
	{name: "--layout-guild-list-width", kind: "dimension", groupId: "layout", groupLabel: "Layout", source: "globals"},
	{name: "--layout-header-height", kind: "dimension", groupId: "layout", groupLabel: "Layout", source: "globals"},
	{name: "--layout-header-height-mobile", kind: "dimension", groupId: "layout", groupLabel: "Layout", source: "globals"},
	{name: "--layout-header-popout-width", kind: "dimension", groupId: "layout", groupLabel: "Layout", source: "globals"},
	{name: "--layout-member-list-width", kind: "dimension", groupId: "layout", groupLabel: "Layout", source: "globals"},
	{name: "--layout-mobile-bottom-nav-reserved-height", kind: "dimension", groupId: "layout", groupLabel: "Layout", source: "globals"},
	{name: "--layout-sidebar-width", kind: "dimension", groupId: "layout", groupLabel: "Layout", source: "globals"},
	{name: "--layout-user-area-height", kind: "dimension", groupId: "layout", groupLabel: "Layout", source: "globals"},
	{name: "--layout-user-area-reserved-height", kind: "dimension", groupId: "layout", groupLabel: "Layout", source: "globals"},
	{name: "--layout-voice-connection-height", kind: "dimension", groupId: "layout", groupLabel: "Layout", source: "globals"},
	{name: "--link-decoration", kind: "other", groupId: "other", groupLabel: "Other", source: "runtime-accessibility"},
	{name: "--list-row-min-height", kind: "dimension", groupId: "layout", groupLabel: "Layout", source: "globals"},
	{name: "--macos-traffic-light-inset", kind: "dimension", groupId: "other", groupLabel: "Other", source: "globals"},
	{name: "--markup-everyone-border", kind: "color", groupId: "markup", groupLabel: "Markup & mentions", source: "color-system"},
	{name: "--markup-everyone-fill", kind: "color", groupId: "markup", groupLabel: "Markup & mentions", source: "color-system"},
	{name: "--markup-everyone-text", kind: "color", groupId: "markup", groupLabel: "Markup & mentions", source: "color-system"},
	{name: "--markup-here-border", kind: "color", groupId: "markup", groupLabel: "Markup & mentions", source: "color-system"},
	{name: "--markup-here-fill", kind: "color", groupId: "markup", groupLabel: "Markup & mentions", source: "color-system"},
	{name: "--markup-here-text", kind: "color", groupId: "markup", groupLabel: "Markup & mentions", source: "color-system"},
	{name: "--markup-interactive-hover-fill", kind: "color", groupId: "markup", groupLabel: "Markup & mentions", source: "color-system"},
	{name: "--markup-interactive-hover-text", kind: "color", groupId: "markup", groupLabel: "Markup & mentions", source: "color-system"},
	{name: "--markup-jump-link-fill", kind: "color", groupId: "markup", groupLabel: "Markup & mentions", source: "color-system"},
	{name: "--markup-jump-link-hover-fill", kind: "color", groupId: "markup", groupLabel: "Markup & mentions", source: "color-system"},
	{name: "--markup-jump-link-text", kind: "color", groupId: "markup", groupLabel: "Markup & mentions", source: "color-system"},
	{name: "--markup-mention-border", kind: "color", groupId: "markup", groupLabel: "Markup & mentions", source: "color-system"},
	{name: "--markup-mention-fill", kind: "color", groupId: "markup", groupLabel: "Markup & mentions", source: "color-system"},
	{name: "--markup-mention-text", kind: "color", groupId: "markup", groupLabel: "Markup & mentions", source: "color-system"},
	{name: "--markup-restricted-inline-emoji-baseline-shift", kind: "dimension", groupId: "emoji", groupLabel: "Emoji", source: "globals"},
	{name: "--markup-restricted-inline-emoji-size", kind: "dimension", groupId: "emoji", groupLabel: "Emoji", source: "globals"},
	{name: "--markup-restricted-inline-icon-baseline-shift", kind: "dimension", groupId: "markup", groupLabel: "Markup & mentions", source: "globals"},
	{name: "--markup-strikethrough-color", kind: "color", groupId: "markup", groupLabel: "Markup & mentions", source: "runtime-accessibility"},
	{name: "--media-border-radius", kind: "dimension", groupId: "borders", groupLabel: "Borders & focus", source: "globals"},
	{name: "--member-list-group-spacer-height", kind: "dimension", groupId: "layout", groupLabel: "Layout", source: "globals"},
	{name: "--member-list-item-content-gap", kind: "dimension", groupId: "layout", groupLabel: "Layout", source: "globals"},
	{name: "--member-list-item-content-height", kind: "dimension", groupId: "layout", groupLabel: "Layout", source: "globals"},
	{name: "--member-list-item-name-line-height", kind: "dimension", groupId: "layout", groupLabel: "Layout", source: "globals"},
	{name: "--member-list-item-padding-block", kind: "dimension", groupId: "layout", groupLabel: "Layout", source: "globals"},
	{name: "--member-list-item-padding-inline", kind: "dimension", groupId: "layout", groupLabel: "Layout", source: "globals"},
	{name: "--member-list-item-status-line-height", kind: "dimension", groupId: "layout", groupLabel: "Layout", source: "globals"},
	{name: "--member-list-row-gap", kind: "dimension", groupId: "layout", groupLabel: "Layout", source: "globals"},
	{name: "--member-list-scroller-padding-block-end", kind: "dimension", groupId: "layout", groupLabel: "Layout", source: "globals"},
	{name: "--member-list-scroller-padding-block-start", kind: "dimension", groupId: "layout", groupLabel: "Layout", source: "globals"},
	{name: "--member-list-scroller-padding-inline", kind: "dimension", groupId: "layout", groupLabel: "Layout", source: "globals"},
	{name: "--mention-badge-medium-size", kind: "dimension", groupId: "layout", groupLabel: "Layout", source: "globals"},
	{name: "--mention-badge-small-size", kind: "dimension", groupId: "layout", groupLabel: "Layout", source: "globals"},
	{name: "--message-action-bar-offset", kind: "dimension", groupId: "messages", groupLabel: "Messages", source: "message-layout"},
	{name: "--message-avatar-align-offset", kind: "dimension", groupId: "messages", groupLabel: "Messages", source: "message-layout"},
	{name: "--message-avatar-size", kind: "dimension", groupId: "messages", groupLabel: "Messages", source: "message-layout"},
	{name: "--message-avatar-size-compact", kind: "dimension", groupId: "messages", groupLabel: "Messages", source: "message-layout"},
	{name: "--message-compact-container-margin", kind: "dimension", groupId: "messages", groupLabel: "Messages", source: "message-layout"},
	{name: "--message-compact-gap", kind: "dimension", groupId: "messages", groupLabel: "Messages", source: "message-layout"},
	{name: "--message-compact-horizontal-padding", kind: "dimension", groupId: "messages", groupLabel: "Messages", source: "globals"},
	{name: "--message-compact-indent", kind: "dimension", groupId: "messages", groupLabel: "Messages", source: "message-layout"},
	{name: "--message-compact-markdown-alert-padding-block", kind: "dimension", groupId: "messages", groupLabel: "Messages", source: "message-layout"},
	{name: "--message-compact-markdown-alert-padding-inline", kind: "dimension", groupId: "messages", groupLabel: "Messages", source: "message-layout"},
	{name: "--message-compact-markdown-block-gap", kind: "dimension", groupId: "messages", groupLabel: "Messages", source: "message-layout"},
	{name: "--message-compact-markdown-blockquote-divider-margin-end", kind: "dimension", groupId: "messages", groupLabel: "Messages", source: "message-layout"},
	{name: "--message-compact-markdown-blockquote-gap", kind: "dimension", groupId: "messages", groupLabel: "Messages", source: "message-layout"},
	{name: "--message-compact-table-max-inline-size", kind: "other", groupId: "messages", groupLabel: "Messages", source: "message-layout"},
	{name: "--message-compact-table-min-cell-width", kind: "dimension", groupId: "messages", groupLabel: "Messages", source: "message-layout"},
	{name: "--message-compact-text-indent-from-username", kind: "dimension", groupId: "messages", groupLabel: "Messages", source: "globals"},
	{name: "--message-compact-timestamp-width", kind: "dimension", groupId: "messages", groupLabel: "Messages", source: "message-layout"},
	{name: "--message-compact-username-gap", kind: "dimension", groupId: "messages", groupLabel: "Messages", source: "message-layout"},
	{name: "--message-container-gap", kind: "dimension", groupId: "messages", groupLabel: "Messages", source: "message-layout"},
	{name: "--message-container-padding-y", kind: "dimension", groupId: "messages", groupLabel: "Messages", source: "message-layout"},
	{name: "--message-edited-font-size", kind: "dimension", groupId: "messages", groupLabel: "Messages", source: "message-layout"},
	{name: "--message-edited-label-font-size", kind: "dimension", groupId: "messages", groupLabel: "Messages", source: "message-layout"},
	{name: "--message-failed-indicator-font-size", kind: "dimension", groupId: "messages", groupLabel: "Messages", source: "message-layout"},
	{name: "--message-failed-indicator-gap", kind: "dimension", groupId: "messages", groupLabel: "Messages", source: "message-layout"},
	{name: "--message-failed-opacity", kind: "number", groupId: "messages", groupLabel: "Messages", source: "features/theme/styles/Message.module.css"},
	{name: "--message-filler-padding-bottom", kind: "dimension", groupId: "messages", groupLabel: "Messages", source: "globals"},
	{name: "--message-group-spacing", kind: "dimension", groupId: "messages", groupLabel: "Messages", source: "runtime-accessibility"},
	{name: "--message-gutter", kind: "dimension", groupId: "messages", groupLabel: "Messages", source: "message-layout"},
	{name: "--message-highlight-bar-width", kind: "dimension", groupId: "messages", groupLabel: "Messages", source: "features/theme/styles/Message.module.css"},
	{name: "--message-icon-size-lg", kind: "dimension", groupId: "messages", groupLabel: "Messages", source: "message-layout"},
	{name: "--message-icon-size-md", kind: "dimension", groupId: "messages", groupLabel: "Messages", source: "message-layout"},
	{name: "--message-icon-size-sm", kind: "dimension", groupId: "messages", groupLabel: "Messages", source: "message-layout"},
	{name: "--message-line-height", kind: "dimension", groupId: "messages", groupLabel: "Messages", source: "message-layout"},
	{name: "--message-mention-bg", kind: "color", groupId: "messages", groupLabel: "Messages", source: "features/theme/styles/Message.module.css"},
	{name: "--message-mention-bg-hover", kind: "color", groupId: "messages", groupLabel: "Messages", source: "features/theme/styles/Message.module.css"},
	{name: "--message-mention-color", kind: "color", groupId: "messages", groupLabel: "Messages", source: "features/theme/styles/Message.module.css"},
	{name: "--message-mobile-margin", kind: "dimension", groupId: "messages", groupLabel: "Messages", source: "message-layout"},
	{name: "--message-preview-card-background", kind: "color", groupId: "messages", groupLabel: "Messages", source: "globals"},
	{name: "--message-preview-card-border", kind: "color", groupId: "messages", groupLabel: "Messages", source: "globals"},
	{name: "--message-preview-card-divider", kind: "color", groupId: "messages", groupLabel: "Messages", source: "globals"},
	{name: "--message-replied-username-opacity", kind: "number", groupId: "messages", groupLabel: "Messages", source: "features/theme/styles/Message.module.css"},
	{name: "--message-reply-bg", kind: "color", groupId: "messages", groupLabel: "Messages", source: "features/theme/styles/Message.module.css"},
	{name: "--message-reply-color", kind: "color", groupId: "messages", groupLabel: "Messages", source: "features/theme/styles/Message.module.css"},
	{name: "--message-reply-font-size", kind: "dimension", groupId: "messages", groupLabel: "Messages", source: "message-layout"},
	{name: "--message-reply-height", kind: "dimension", groupId: "messages", groupLabel: "Messages", source: "message-layout"},
	{name: "--message-reply-spacing", kind: "dimension", groupId: "messages", groupLabel: "Messages", source: "message-layout"},
	{name: "--message-reply-spine-radius", kind: "dimension", groupId: "messages", groupLabel: "Messages", source: "message-layout"},
	{name: "--message-reply-spine-width", kind: "dimension", groupId: "messages", groupLabel: "Messages", source: "message-layout"},
	{name: "--message-search-bar-height", kind: "dimension", groupId: "messages", groupLabel: "Messages", source: "globals"},
	{name: "--message-search-bar-icon-gap", kind: "dimension", groupId: "messages", groupLabel: "Messages", source: "globals"},
	{name: "--message-search-bar-icon-size", kind: "dimension", groupId: "messages", groupLabel: "Messages", source: "globals"},
	{name: "--message-search-bar-width", kind: "dimension", groupId: "messages", groupLabel: "Messages", source: "globals"},
	{name: "--message-sending-link-opacity", kind: "number", groupId: "messages", groupLabel: "Messages", source: "features/theme/styles/Message.module.css"},
	{name: "--message-sending-opacity", kind: "number", groupId: "messages", groupLabel: "Messages", source: "features/theme/styles/Message.module.css"},
	{name: "--message-spacing-y", kind: "dimension", groupId: "messages", groupLabel: "Messages", source: "message-layout"},
	{name: "--message-timestamp-color", kind: "color", groupId: "messages", groupLabel: "Messages", source: "features/theme/styles/Message.module.css"},
	{name: "--message-timestamp-compact-font-size", kind: "dimension", groupId: "messages", groupLabel: "Messages", source: "message-layout"},
	{name: "--message-timestamp-compact-height", kind: "dimension", groupId: "messages", groupLabel: "Messages", source: "message-layout"},
	{name: "--message-timestamp-font-size", kind: "dimension", groupId: "messages", groupLabel: "Messages", source: "message-layout"},
	{name: "--message-transition-highlight", kind: "transition", groupId: "messages", groupLabel: "Messages", source: "features/theme/styles/Message.module.css"},
	{name: "--message-typing-avatar-margin", kind: "dimension", groupId: "messages", groupLabel: "Messages", source: "message-layout"},
	{name: "--message-typing-gap", kind: "dimension", groupId: "messages", groupLabel: "Messages", source: "message-layout"},
	{name: "--message-typing-pill-gap", kind: "dimension", groupId: "messages", groupLabel: "Messages", source: "message-layout"},
	{name: "--message-typing-pill-padding", kind: "dimension", groupId: "messages", groupLabel: "Messages", source: "message-layout"},
	{name: "--message-typing-text-font-size", kind: "dimension", groupId: "messages", groupLabel: "Messages", source: "message-layout"},
	{name: "--message-unknown-warning-color", kind: "color", groupId: "messages", groupLabel: "Messages", source: "features/theme/styles/Message.module.css"},
	{name: "--messages-bottom-clearance", kind: "dimension", groupId: "messages", groupLabel: "Messages", source: "globals"},
	{name: "--mobile-bottom-nav-height", kind: "dimension", groupId: "layout", groupLabel: "Layout", source: "globals"},
	{name: "--native-titlebar-height", kind: "dimension", groupId: "layout", groupLabel: "Layout", source: "globals"},
	{name: "--outline-frame-border-width", kind: "dimension", groupId: "borders", groupLabel: "Borders & focus", source: "globals"},
	{name: "--outline-frame-radius-native", kind: "dimension", groupId: "borders", groupLabel: "Borders & focus", source: "globals"},
	{name: "--panel-control-bg", kind: "color", groupId: "surfaces", groupLabel: "Surfaces", source: "color-system"},
	{name: "--panel-control-border", kind: "color", groupId: "borders", groupLabel: "Borders & focus", source: "color-system"},
	{name: "--panel-control-divider", kind: "color", groupId: "other", groupLabel: "Other", source: "color-system"},
	{name: "--panel-control-highlight", kind: "color", groupId: "other", groupLabel: "Other", source: "color-system"},
	{name: "--plutonium", kind: "color", groupId: "brand", groupLabel: "Brand & accents", source: "color-system"},
	{name: "--plutonium-hover", kind: "color", groupId: "brand", groupLabel: "Brand & accents", source: "color-system"},
	{name: "--plutonium-icon", kind: "color", groupId: "brand", groupLabel: "Brand & accents", source: "color-system"},
	{name: "--plutonium-text", kind: "color", groupId: "brand", groupLabel: "Brand & accents", source: "color-system"},
	{name: "--radius-2xl", kind: "dimension", groupId: "borders", groupLabel: "Borders & focus", source: "globals"},
	{name: "--radius-full", kind: "dimension", groupId: "borders", groupLabel: "Borders & focus", source: "globals"},
	{name: "--radius-lg", kind: "dimension", groupId: "borders", groupLabel: "Borders & focus", source: "globals"},
	{name: "--radius-md", kind: "dimension", groupId: "borders", groupLabel: "Borders & focus", source: "globals"},
	{name: "--radius-sm", kind: "dimension", groupId: "borders", groupLabel: "Borders & focus", source: "globals"},
	{name: "--radius-xl", kind: "dimension", groupId: "borders", groupLabel: "Borders & focus", source: "globals"},
	{name: "--saturation-factor", kind: "number", groupId: "other", groupLabel: "Other", source: "globals"},
	{name: "--scrollbar-thumb-bg", kind: "color", groupId: "scrolling", groupLabel: "Scrolling", source: "color-system"},
	{name: "--scrollbar-thumb-bg-hover", kind: "color", groupId: "scrolling", groupLabel: "Scrolling", source: "color-system"},
	{name: "--scrollbar-track-bg", kind: "color", groupId: "scrolling", groupLabel: "Scrolling", source: "color-system"},
	{name: "--scroller-spacer-height", kind: "dimension", groupId: "layout", groupLabel: "Layout", source: "globals"},
	{name: "--shadow-lg", kind: "shadow", groupId: "borders", groupLabel: "Borders & focus", source: "color-system"},
	{name: "--shadow-md", kind: "shadow", groupId: "borders", groupLabel: "Borders & focus", source: "color-system"},
	{name: "--shadow-sm", kind: "shadow", groupId: "borders", groupLabel: "Borders & focus", source: "color-system"},
	{name: "--shadow-xl", kind: "shadow", groupId: "borders", groupLabel: "Borders & focus", source: "color-system"},
	{name: "--skeleton-chrome-border", kind: "other", groupId: "borders", groupLabel: "Borders & focus", source: "globals"},
	{name: "--skeleton-chrome-border-color", kind: "color", groupId: "borders", groupLabel: "Borders & focus", source: "globals"},
	{name: "--skeleton-opacity-default", kind: "number", groupId: "other", groupLabel: "Other", source: "globals"},
	{name: "--skeleton-opacity-muted", kind: "number", groupId: "other", groupLabel: "Other", source: "globals"},
	{name: "--skeleton-opacity-strong", kind: "number", groupId: "other", groupLabel: "Other", source: "globals"},
	{name: "--slowmode-indicator-height", kind: "dimension", groupId: "layout", groupLabel: "Layout", source: "globals"},
	{name: "--spacing-0", kind: "dimension", groupId: "layout", groupLabel: "Layout", source: "globals"},
	{name: "--spacing-1", kind: "dimension", groupId: "layout", groupLabel: "Layout", source: "globals"},
	{name: "--spacing-1-5", kind: "dimension", groupId: "layout", groupLabel: "Layout", source: "globals"},
	{name: "--spacing-10", kind: "dimension", groupId: "layout", groupLabel: "Layout", source: "globals"},
	{name: "--spacing-12", kind: "dimension", groupId: "layout", groupLabel: "Layout", source: "globals"},
	{name: "--spacing-16", kind: "dimension", groupId: "layout", groupLabel: "Layout", source: "globals"},
	{name: "--spacing-2", kind: "dimension", groupId: "layout", groupLabel: "Layout", source: "globals"},
	{name: "--spacing-20", kind: "dimension", groupId: "layout", groupLabel: "Layout", source: "globals"},
	{name: "--spacing-24", kind: "dimension", groupId: "layout", groupLabel: "Layout", source: "globals"},
	{name: "--spacing-3", kind: "dimension", groupId: "layout", groupLabel: "Layout", source: "globals"},
	{name: "--spacing-4", kind: "dimension", groupId: "layout", groupLabel: "Layout", source: "globals"},
	{name: "--spacing-5", kind: "dimension", groupId: "layout", groupLabel: "Layout", source: "globals"},
	{name: "--spacing-6", kind: "dimension", groupId: "layout", groupLabel: "Layout", source: "globals"},
	{name: "--spacing-8", kind: "dimension", groupId: "layout", groupLabel: "Layout", source: "globals"},
	{name: "--spoiler-border-radius", kind: "dimension", groupId: "markup", groupLabel: "Markup & mentions", source: "globals"},
	{name: "--spoiler-overlay-color", kind: "color", groupId: "markup", groupLabel: "Markup & mentions", source: "color-system"},
	{name: "--spoiler-overlay-hover-color", kind: "color", groupId: "markup", groupLabel: "Markup & mentions", source: "color-system"},
	{name: "--status-danger", kind: "color", groupId: "status", groupLabel: "Status indicators", source: "color-system"},
	{name: "--status-dnd", kind: "color", groupId: "status", groupLabel: "Status indicators", source: "color-system"},
	{name: "--status-idle", kind: "color", groupId: "status", groupLabel: "Status indicators", source: "color-system"},
	{name: "--status-offline", kind: "color", groupId: "status", groupLabel: "Status indicators", source: "color-system"},
	{name: "--status-online", kind: "color", groupId: "status", groupLabel: "Status indicators", source: "color-system"},
	{name: "--status-warning", kind: "color", groupId: "status", groupLabel: "Status indicators", source: "color-system"},
	{name: "--surface-interactive-hover-bg", kind: "color", groupId: "surfaces", groupLabel: "Surfaces", source: "globals"},
	{name: "--surface-interactive-selected-bg", kind: "color", groupId: "surfaces", groupLabel: "Surfaces", source: "globals"},
	{name: "--surface-interactive-selected-color", kind: "color", groupId: "surfaces", groupLabel: "Surfaces", source: "globals"},
	{name: "--system-message-icon-opacity", kind: "number", groupId: "other", groupLabel: "Other", source: "features/theme/styles/Message.module.css"},
	{name: "--system-message-icon-size", kind: "dimension", groupId: "layout", groupLabel: "Layout", source: "message-layout"},
	{name: "--text-chat", kind: "color", groupId: "text", groupLabel: "Text", source: "color-system"},
	{name: "--text-chat-muted", kind: "color", groupId: "text", groupLabel: "Text", source: "color-system"},
	{name: "--text-code", kind: "color", groupId: "code", groupLabel: "Code & terminal", source: "color-system"},
	{name: "--text-link", kind: "color", groupId: "text", groupLabel: "Text", source: "color-system"},
	{name: "--text-on-brand-primary", kind: "color", groupId: "text", groupLabel: "Text", source: "color-system"},
	{name: "--text-on-brand-primary-light", kind: "color", groupId: "text", groupLabel: "Text", source: "color-system"},
	{name: "--text-on-brand-tint", kind: "color", groupId: "text", groupLabel: "Text", source: "color-system"},
	{name: "--text-on-dark", kind: "color", groupId: "text", groupLabel: "Text", source: "color-system"},
	{name: "--text-primary", kind: "color", groupId: "text", groupLabel: "Text", source: "color-system"},
	{name: "--text-primary-muted", kind: "color", groupId: "text", groupLabel: "Text", source: "color-system"},
	{name: "--text-secondary", kind: "color", groupId: "text", groupLabel: "Text", source: "color-system"},
	{name: "--text-selection", kind: "color", groupId: "text", groupLabel: "Text", source: "color-system"},
	{name: "--text-tertiary", kind: "color", groupId: "text", groupLabel: "Text", source: "color-system"},
	{name: "--text-tertiary-muted", kind: "color", groupId: "text", groupLabel: "Text", source: "color-system"},
	{name: "--text-tertiary-secondary", kind: "color", groupId: "text", groupLabel: "Text", source: "color-system"},
	{name: "--text-warning", kind: "color", groupId: "text", groupLabel: "Text", source: "color-system"},
	{name: "--textarea-button-compact-height", kind: "dimension", groupId: "forms", groupLabel: "Forms", source: "globals"},
	{name: "--textarea-button-compact-icon-size", kind: "dimension", groupId: "forms", groupLabel: "Forms", source: "globals"},
	{name: "--textarea-button-height", kind: "dimension", groupId: "forms", groupLabel: "Forms", source: "globals"},
	{name: "--textarea-button-icon-size", kind: "dimension", groupId: "forms", groupLabel: "Forms", source: "globals"},
	{name: "--textarea-container-padding-x", kind: "dimension", groupId: "forms", groupLabel: "Forms", source: "globals"},
	{name: "--textarea-content-offset", kind: "dimension", groupId: "forms", groupLabel: "Forms", source: "globals"},
	{name: "--textarea-font-size", kind: "dimension", groupId: "forms", groupLabel: "Forms", source: "globals"},
	{name: "--textarea-line-height", kind: "dimension", groupId: "forms", groupLabel: "Forms", source: "globals"},
	{name: "--textarea-min-height", kind: "dimension", groupId: "forms", groupLabel: "Forms", source: "globals"},
	{name: "--textarea-padding-y", kind: "dimension", groupId: "forms", groupLabel: "Forms", source: "globals"},
	{name: "--textarea-side-button-padding", kind: "dimension", groupId: "forms", groupLabel: "Forms", source: "globals"},
	{name: "--textarea-top-bar-height", kind: "dimension", groupId: "forms", groupLabel: "Forms", source: "globals"},
	{name: "--textarea-upload-gap", kind: "dimension", groupId: "forms", groupLabel: "Forms", source: "globals"},
	{name: "--theme-border", kind: "color", groupId: "borders", groupLabel: "Borders & focus", source: "color-system"},
	{name: "--theme-border-width", kind: "dimension", groupId: "borders", groupLabel: "Borders & focus", source: "color-system"},
	{name: "--transition-fast", kind: "transition", groupId: "motion", groupLabel: "Motion", source: "color-system"},
	{name: "--transition-normal", kind: "transition", groupId: "motion", groupLabel: "Motion", source: "color-system"},
	{name: "--transition-slow", kind: "transition", groupId: "motion", groupLabel: "Motion", source: "color-system"},
	{name: "--typing-avatar-size", kind: "dimension", groupId: "messages", groupLabel: "Messages", source: "globals"},
	{name: "--typing-indicator-animation-size", kind: "dimension", groupId: "messages", groupLabel: "Messages", source: "globals"},
	{name: "--typing-indicator-gap", kind: "dimension", groupId: "messages", groupLabel: "Messages", source: "globals"},
	{name: "--typing-indicator-height", kind: "dimension", groupId: "messages", groupLabel: "Messages", source: "globals"},
	{name: "--typing-pill-height", kind: "dimension", groupId: "messages", groupLabel: "Messages", source: "globals"},
	{name: "--user-area-avatar-lead", kind: "dimension", groupId: "media", groupLabel: "Media", source: "globals"},
	{name: "--user-area-box-inset-block-end", kind: "dimension", groupId: "other", groupLabel: "Other", source: "globals"},
	{name: "--user-area-content-height", kind: "dimension", groupId: "layout", groupLabel: "Layout", source: "globals"},
	{name: "--user-area-divider-color", kind: "color", groupId: "other", groupLabel: "Other", source: "color-system"},
	{name: "--user-area-padding-x", kind: "dimension", groupId: "layout", groupLabel: "Layout", source: "globals"},
	{name: "--user-area-padding-y", kind: "dimension", groupId: "layout", groupLabel: "Layout", source: "globals"},
	{name: "--user-select", kind: "other", groupId: "other", groupLabel: "Other", source: "globals"},
	{name: "--voice-connection-padding-x", kind: "dimension", groupId: "layout", groupLabel: "Layout", source: "globals"},
	{name: "--voice-connection-padding-y", kind: "dimension", groupId: "layout", groupLabel: "Layout", source: "globals"},
	{name: "--z-index-base", kind: "number", groupId: "layering", groupLabel: "Layering", source: "globals"},
	{name: "--z-index-contextmenu", kind: "number", groupId: "layering", groupLabel: "Layering", source: "globals"},
	{name: "--z-index-elevated-1", kind: "number", groupId: "layering", groupLabel: "Layering", source: "globals"},
	{name: "--z-index-elevated-2", kind: "number", groupId: "layering", groupLabel: "Layering", source: "globals"},
	{name: "--z-index-elevated-3", kind: "number", groupId: "layering", groupLabel: "Layering", source: "globals"},
	{name: "--z-index-modal", kind: "number", groupId: "layering", groupLabel: "Layering", source: "globals"},
	{name: "--z-index-modal-swap", kind: "number", groupId: "layering", groupLabel: "Layering", source: "globals"},
	{name: "--z-index-overlay", kind: "number", groupId: "layering", groupLabel: "Layering", source: "globals"},
	{name: "--z-index-popout", kind: "number", groupId: "layering", groupLabel: "Layering", source: "globals"},
	{name: "--z-index-popout-above-swap", kind: "number", groupId: "layering", groupLabel: "Layering", source: "globals"},
	{name: "--z-index-titlebar", kind: "number", groupId: "layering", groupLabel: "Layering", source: "globals"},
	{name: "--z-index-toast", kind: "number", groupId: "layering", groupLabel: "Layering", source: "globals"},
	{name: "--z-index-tooltip", kind: "number", groupId: "layering", groupLabel: "Layering", source: "globals"},
];

export const THEME_VARIABLE_NAMES: ReadonlyArray<string> = [
	"--accent-danger",
	"--accent-info",
	"--accent-primary",
	"--accent-purple",
	"--accent-success",
	"--accent-warning",
	"--active-now-action-gap",
	"--active-now-action-height",
	"--active-now-action-padding-block",
	"--active-now-action-padding-inline",
	"--active-now-action-radius",
	"--active-now-card-gap",
	"--active-now-card-padding-block",
	"--active-now-card-padding-inline",
	"--active-now-card-radius",
	"--active-now-card-shadow",
	"--active-now-context-gap",
	"--active-now-sidebar-content-gap",
	"--active-now-sidebar-content-padding-block-end",
	"--active-now-sidebar-content-padding-inline",
	"--active-now-sidebar-header-padding-block-end",
	"--active-now-sidebar-header-padding-block-start",
	"--active-now-sidebar-header-padding-inline",
	"--active-now-sidebar-width",
	"--alert-caution-color",
	"--alert-important-color",
	"--alert-note-color",
	"--alert-tip-color",
	"--alert-warning-color",
	"--ansi-bg-black",
	"--ansi-bg-blue",
	"--ansi-bg-bright-black",
	"--ansi-bg-bright-blue",
	"--ansi-bg-bright-cyan",
	"--ansi-bg-bright-green",
	"--ansi-bg-bright-magenta",
	"--ansi-bg-bright-red",
	"--ansi-bg-bright-white",
	"--ansi-bg-bright-yellow",
	"--ansi-bg-cyan",
	"--ansi-bg-green",
	"--ansi-bg-magenta",
	"--ansi-bg-red",
	"--ansi-bg-white",
	"--ansi-bg-yellow",
	"--ansi-fg-black",
	"--ansi-fg-blue",
	"--ansi-fg-bright-black",
	"--ansi-fg-bright-blue",
	"--ansi-fg-bright-cyan",
	"--ansi-fg-bright-green",
	"--ansi-fg-bright-magenta",
	"--ansi-fg-bright-red",
	"--ansi-fg-bright-white",
	"--ansi-fg-bright-yellow",
	"--ansi-fg-cyan",
	"--ansi-fg-green",
	"--ansi-fg-magenta",
	"--ansi-fg-red",
	"--ansi-fg-white",
	"--ansi-fg-yellow",
	"--ansi-inverse-bg",
	"--ansi-inverse-text",
	"--avatar-stack-extra-height",
	"--background-channel-header",
	"--background-header-primary",
	"--background-header-primary-hover",
	"--background-header-secondary",
	"--background-modifier-accent",
	"--background-modifier-accent-focus",
	"--background-modifier-hover",
	"--background-modifier-selected",
	"--background-primary",
	"--background-secondary",
	"--background-secondary-alt",
	"--background-secondary-lighter",
	"--background-tertiary",
	"--background-textarea",
	"--bg-active",
	"--bg-blockquote",
	"--bg-code",
	"--bg-code-block",
	"--bg-hover",
	"--bg-primary",
	"--bg-secondary",
	"--bg-table-header",
	"--bg-table-row-even",
	"--bg-table-row-odd",
	"--bg-tertiary",
	"--border-color",
	"--border-color-focus",
	"--border-color-hover",
	"--brand-primary",
	"--brand-primary-fill",
	"--brand-primary-foreground",
	"--brand-primary-light",
	"--brand-primary-light-fill",
	"--brand-primary-pressed",
	"--brand-primary-shade",
	"--brand-secondary",
	"--brand-tint",
	"--brand-tint-border",
	"--brand-tint-hover",
	"--button-danger-active-fill",
	"--button-danger-fill",
	"--button-danger-outline-active-border",
	"--button-danger-outline-active-fill",
	"--button-danger-outline-border",
	"--button-danger-outline-text",
	"--button-danger-text",
	"--button-ghost-text",
	"--button-inverted-fill",
	"--button-inverted-text",
	"--button-outline-active-border",
	"--button-outline-active-fill",
	"--button-outline-border",
	"--button-outline-text",
	"--button-primary-active-fill",
	"--button-primary-fill",
	"--button-primary-text",
	"--button-secondary-active-fill",
	"--button-secondary-active-text",
	"--button-secondary-fill",
	"--button-secondary-text",
	"--channel-header-action-icon-size",
	"--channel-header-action-size",
	"--channel-header-action-size-mobile",
	"--channel-header-actions-gap",
	"--channel-header-back-button-gap",
	"--channel-header-back-button-size",
	"--channel-header-back-icon-size",
	"--channel-header-caret-gap",
	"--channel-header-caret-size",
	"--channel-header-gap",
	"--channel-header-icon-size",
	"--channel-header-name-gap",
	"--channel-header-name-gap-group-dm",
	"--channel-header-padding-inline",
	"--channel-header-topic-divider-gap",
	"--chat-horizontal-padding",
	"--chat-horizontal-padding-default",
	"--chat-mobile-horizontal-padding",
	"--code-block-bg",
	"--code-block-border",
	"--code-block-highlight",
	"--code-inline-bg",
	"--code-muted",
	"--code-text",
	"--composer-action-gap",
	"--composer-box-inset",
	"--composer-box-inset-inline",
	"--composer-box-padding-inline",
	"--composer-mobile-box-height",
	"--composer-mobile-padding-y",
	"--composer-status-line-height",
	"--composer-status-row-height",
	"--composer-status-safe-area",
	"--composer-status-safe-gap",
	"--composer-surface-color",
	"--content-padding",
	"--content-padding-lg",
	"--content-padding-sm",
	"--control-button-active-bg",
	"--control-button-active-text",
	"--control-button-danger-hover-bg",
	"--control-button-danger-text",
	"--control-button-hover-bg",
	"--control-button-hover-text",
	"--control-button-normal-bg",
	"--control-button-normal-text",
	"--count-indicator-gap",
	"--discovery-card-description-min-height",
	"--dm-sidebar-mobile-header-height",
	"--emoji-size-emoji",
	"--emoji-size-jumbo-emoji",
	"--floating-surface-ring-color",
	"--floating-surface-ring-color-strong",
	"--focus-primary",
	"--folder-radius",
	"--font-fallback-mono",
	"--font-fallback-sans",
	"--font-keybind",
	"--font-mono",
	"--font-sans",
	"--font-sans-primary",
	"--font-size",
	"--font-size-xs",
	"--footer-box-height",
	"--footer-box-inner-inset",
	"--footer-box-inset",
	"--footer-box-inset-inline",
	"--footer-box-padding-y",
	"--footer-box-radius",
	"--footer-row-height",
	"--form-surface-background",
	"--friend-row-action-gap",
	"--friend-row-action-size",
	"--friend-row-avatar-size",
	"--friend-row-content-gap",
	"--friend-row-name-line-height",
	"--friend-row-padding-block",
	"--friend-row-padding-inline",
	"--friend-row-separator-inset",
	"--friend-row-separator-radius",
	"--friend-row-subtext-line-height",
	"--friend-row-subtext-offset",
	"--guild-badge-surface",
	"--guild-folder-expanded-surface-size",
	"--guild-icon-gap",
	"--guild-icon-size",
	"--guild-list-divider-base-gap",
	"--guild-list-divider-line-size",
	"--guild-list-foreground",
	"--guild-list-indicator-bar-width",
	"--guild-list-indicator-inset",
	"--guild-list-indicator-track-width",
	"--guild-list-item-box-size",
	"--guild-list-item-gap",
	"--guild-list-item-target-half-extra",
	"--guild-list-item-target-size",
	"--guild-members-columns",
	"--guild-members-columns-selectable",
	"--guild-members-min-width",
	"--guild-members-min-width-selectable",
	"--guild-members-select-column-width",
	"--guild-members-table-row-border-width",
	"--guild-members-table-row-min-height",
	"--guilds-layout-item-bg",
	"--input-container-min-height",
	"--input-container-padding",
	"--input-wrapper-padding-bottom",
	"--input-wrapper-padding-x",
	"--interactive-active",
	"--interactive-muted",
	"--invite-verified-icon-color",
	"--layout-gap",
	"--layout-gap-lg",
	"--layout-gap-sm",
	"--layout-guild-list-width",
	"--layout-header-height",
	"--layout-header-height-mobile",
	"--layout-header-popout-width",
	"--layout-member-list-width",
	"--layout-mobile-bottom-nav-reserved-height",
	"--layout-sidebar-width",
	"--layout-user-area-height",
	"--layout-user-area-reserved-height",
	"--layout-voice-connection-height",
	"--link-decoration",
	"--list-row-min-height",
	"--macos-traffic-light-inset",
	"--markup-everyone-border",
	"--markup-everyone-fill",
	"--markup-everyone-text",
	"--markup-here-border",
	"--markup-here-fill",
	"--markup-here-text",
	"--markup-interactive-hover-fill",
	"--markup-interactive-hover-text",
	"--markup-jump-link-fill",
	"--markup-jump-link-hover-fill",
	"--markup-jump-link-text",
	"--markup-mention-border",
	"--markup-mention-fill",
	"--markup-mention-text",
	"--markup-restricted-inline-emoji-baseline-shift",
	"--markup-restricted-inline-emoji-size",
	"--markup-restricted-inline-icon-baseline-shift",
	"--markup-strikethrough-color",
	"--media-border-radius",
	"--member-list-group-spacer-height",
	"--member-list-item-content-gap",
	"--member-list-item-content-height",
	"--member-list-item-name-line-height",
	"--member-list-item-padding-block",
	"--member-list-item-padding-inline",
	"--member-list-item-status-line-height",
	"--member-list-row-gap",
	"--member-list-scroller-padding-block-end",
	"--member-list-scroller-padding-block-start",
	"--member-list-scroller-padding-inline",
	"--mention-badge-medium-size",
	"--mention-badge-small-size",
	"--message-action-bar-offset",
	"--message-avatar-align-offset",
	"--message-avatar-size",
	"--message-avatar-size-compact",
	"--message-compact-container-margin",
	"--message-compact-gap",
	"--message-compact-horizontal-padding",
	"--message-compact-indent",
	"--message-compact-markdown-alert-padding-block",
	"--message-compact-markdown-alert-padding-inline",
	"--message-compact-markdown-block-gap",
	"--message-compact-markdown-blockquote-divider-margin-end",
	"--message-compact-markdown-blockquote-gap",
	"--message-compact-table-max-inline-size",
	"--message-compact-table-min-cell-width",
	"--message-compact-text-indent-from-username",
	"--message-compact-timestamp-width",
	"--message-compact-username-gap",
	"--message-container-gap",
	"--message-container-padding-y",
	"--message-edited-font-size",
	"--message-edited-label-font-size",
	"--message-failed-indicator-font-size",
	"--message-failed-indicator-gap",
	"--message-failed-opacity",
	"--message-filler-padding-bottom",
	"--message-group-spacing",
	"--message-gutter",
	"--message-highlight-bar-width",
	"--message-icon-size-lg",
	"--message-icon-size-md",
	"--message-icon-size-sm",
	"--message-line-height",
	"--message-mention-bg",
	"--message-mention-bg-hover",
	"--message-mention-color",
	"--message-mobile-margin",
	"--message-preview-card-background",
	"--message-preview-card-border",
	"--message-preview-card-divider",
	"--message-replied-username-opacity",
	"--message-reply-bg",
	"--message-reply-color",
	"--message-reply-font-size",
	"--message-reply-height",
	"--message-reply-spacing",
	"--message-reply-spine-radius",
	"--message-reply-spine-width",
	"--message-search-bar-height",
	"--message-search-bar-icon-gap",
	"--message-search-bar-icon-size",
	"--message-search-bar-width",
	"--message-sending-link-opacity",
	"--message-sending-opacity",
	"--message-spacing-y",
	"--message-timestamp-color",
	"--message-timestamp-compact-font-size",
	"--message-timestamp-compact-height",
	"--message-timestamp-font-size",
	"--message-transition-highlight",
	"--message-typing-avatar-margin",
	"--message-typing-gap",
	"--message-typing-pill-gap",
	"--message-typing-pill-padding",
	"--message-typing-text-font-size",
	"--message-unknown-warning-color",
	"--messages-bottom-clearance",
	"--mobile-bottom-nav-height",
	"--native-titlebar-height",
	"--outline-frame-border-width",
	"--outline-frame-radius-native",
	"--panel-control-bg",
	"--panel-control-border",
	"--panel-control-divider",
	"--panel-control-highlight",
	"--plutonium",
	"--plutonium-hover",
	"--plutonium-icon",
	"--plutonium-text",
	"--radius-2xl",
	"--radius-full",
	"--radius-lg",
	"--radius-md",
	"--radius-sm",
	"--radius-xl",
	"--saturation-factor",
	"--scrollbar-thumb-bg",
	"--scrollbar-thumb-bg-hover",
	"--scrollbar-track-bg",
	"--scroller-spacer-height",
	"--shadow-lg",
	"--shadow-md",
	"--shadow-sm",
	"--shadow-xl",
	"--skeleton-chrome-border",
	"--skeleton-chrome-border-color",
	"--skeleton-opacity-default",
	"--skeleton-opacity-muted",
	"--skeleton-opacity-strong",
	"--slowmode-indicator-height",
	"--spacing-0",
	"--spacing-1",
	"--spacing-1-5",
	"--spacing-10",
	"--spacing-12",
	"--spacing-16",
	"--spacing-2",
	"--spacing-20",
	"--spacing-24",
	"--spacing-3",
	"--spacing-4",
	"--spacing-5",
	"--spacing-6",
	"--spacing-8",
	"--spoiler-border-radius",
	"--spoiler-overlay-color",
	"--spoiler-overlay-hover-color",
	"--status-danger",
	"--status-dnd",
	"--status-idle",
	"--status-offline",
	"--status-online",
	"--status-warning",
	"--surface-interactive-hover-bg",
	"--surface-interactive-selected-bg",
	"--surface-interactive-selected-color",
	"--system-message-icon-opacity",
	"--system-message-icon-size",
	"--text-chat",
	"--text-chat-muted",
	"--text-code",
	"--text-link",
	"--text-on-brand-primary",
	"--text-on-brand-primary-light",
	"--text-on-brand-tint",
	"--text-on-dark",
	"--text-primary",
	"--text-primary-muted",
	"--text-secondary",
	"--text-selection",
	"--text-tertiary",
	"--text-tertiary-muted",
	"--text-tertiary-secondary",
	"--text-warning",
	"--textarea-button-compact-height",
	"--textarea-button-compact-icon-size",
	"--textarea-button-height",
	"--textarea-button-icon-size",
	"--textarea-container-padding-x",
	"--textarea-content-offset",
	"--textarea-font-size",
	"--textarea-line-height",
	"--textarea-min-height",
	"--textarea-padding-y",
	"--textarea-side-button-padding",
	"--textarea-top-bar-height",
	"--textarea-upload-gap",
	"--theme-border",
	"--theme-border-width",
	"--transition-fast",
	"--transition-normal",
	"--transition-slow",
	"--typing-avatar-size",
	"--typing-indicator-animation-size",
	"--typing-indicator-gap",
	"--typing-indicator-height",
	"--typing-pill-height",
	"--user-area-avatar-lead",
	"--user-area-box-inset-block-end",
	"--user-area-content-height",
	"--user-area-divider-color",
	"--user-area-padding-x",
	"--user-area-padding-y",
	"--user-select",
	"--voice-connection-padding-x",
	"--voice-connection-padding-y",
	"--z-index-base",
	"--z-index-contextmenu",
	"--z-index-elevated-1",
	"--z-index-elevated-2",
	"--z-index-elevated-3",
	"--z-index-modal",
	"--z-index-modal-swap",
	"--z-index-overlay",
	"--z-index-popout",
	"--z-index-popout-above-swap",
	"--z-index-titlebar",
	"--z-index-toast",
	"--z-index-tooltip",
];

export const THEME_DARK_DEFAULT_VARIABLE_VALUES: Readonly<Record<string, string>> = {
	"--accent-danger": "hsl(0, calc(84% * var(--saturation-factor)), 60%)",
	"--accent-info": "hsl(198, calc(92% * var(--saturation-factor)), 70%)",
	"--accent-primary": "hsl(242, calc(70% * var(--saturation-factor)), 55%)",
	"--accent-purple": "hsl(278, calc(85% * var(--saturation-factor)), 65%)",
	"--accent-success": "hsl(152, calc(72% * var(--saturation-factor)), 40%)",
	"--accent-warning": "hsl(45, calc(93% * var(--saturation-factor)), 50%)",
	"--active-now-action-gap": "0.375rem",
	"--active-now-action-height": "2rem",
	"--active-now-action-padding-block": "0.3125rem",
	"--active-now-action-padding-inline": "0.625rem",
	"--active-now-action-radius": "0.5rem",
	"--active-now-card-gap": "0.75rem",
	"--active-now-card-padding-block": "0.75rem",
	"--active-now-card-padding-inline": "0.875rem",
	"--active-now-card-radius": "0.375rem",
	"--active-now-card-shadow": "0 0.375rem 1.125rem rgba(0, 0, 0, 0.08)",
	"--active-now-context-gap": "0.375rem",
	"--active-now-sidebar-content-gap": "0.5rem",
	"--active-now-sidebar-content-padding-block-end": "0.75rem",
	"--active-now-sidebar-content-padding-inline": "0.75rem",
	"--active-now-sidebar-header-padding-block-end": "0.75rem",
	"--active-now-sidebar-header-padding-block-start": "1rem",
	"--active-now-sidebar-header-padding-inline": "1rem",
	"--active-now-sidebar-width": "22rem",
	"--alert-caution-color": "hsl(359, calc(75% * var(--saturation-factor)), 60%)",
	"--alert-important-color": "hsl(278, calc(85% * var(--saturation-factor)), 65%)",
	"--alert-note-color": "hsl(198, calc(92% * var(--saturation-factor)), 70%)",
	"--alert-tip-color": "hsl(152, calc(72% * var(--saturation-factor)), 45%)",
	"--alert-warning-color": "hsl(45, calc(93% * var(--saturation-factor)), 55%)",
	"--ansi-bg-black": "color-mix(in srgb, hsl(0, 0%, 12%) 88%, color-mix(in srgb, hsl(258, calc(10% * var(--saturation-factor)), 14.15%) 92%, hsl(258, calc(10% * var(--saturation-factor)), 5%) 8%) 12%)",
	"--ansi-bg-blue": "color-mix(in srgb, hsl(207, calc(61% * var(--saturation-factor)), 59%) 88%, color-mix(in srgb, hsl(258, calc(10% * var(--saturation-factor)), 14.15%) 92%, hsl(258, calc(10% * var(--saturation-factor)), 5%) 8%) 12%)",
	"--ansi-bg-bright-black": "color-mix(in srgb, hsl(0, 0%, 50%) 88%, color-mix(in srgb, hsl(258, calc(10% * var(--saturation-factor)), 14.15%) 92%, hsl(258, calc(10% * var(--saturation-factor)), 5%) 8%) 12%)",
	"--ansi-bg-bright-blue": "color-mix(in srgb, hsl(207, calc(61% * var(--saturation-factor)), 59%) 92%, color-mix(in srgb, hsl(258, calc(10% * var(--saturation-factor)), 14.15%) 92%, hsl(258, calc(10% * var(--saturation-factor)), 5%) 8%) 8%)",
	"--ansi-bg-bright-cyan": "color-mix(in srgb, hsl(168, calc(53% * var(--saturation-factor)), 55%) 92%, color-mix(in srgb, hsl(258, calc(10% * var(--saturation-factor)), 14.15%) 92%, hsl(258, calc(10% * var(--saturation-factor)), 5%) 8%) 8%)",
	"--ansi-bg-bright-green": "color-mix(in srgb, hsl(99, calc(29% * var(--saturation-factor)), 47%) 92%, color-mix(in srgb, hsl(258, calc(10% * var(--saturation-factor)), 14.15%) 92%, hsl(258, calc(10% * var(--saturation-factor)), 5%) 8%) 8%)",
	"--ansi-bg-bright-magenta": "color-mix(in srgb, hsl(305, calc(35% * var(--saturation-factor)), 65%) 92%, color-mix(in srgb, hsl(258, calc(10% * var(--saturation-factor)), 14.15%) 92%, hsl(258, calc(10% * var(--saturation-factor)), 5%) 8%) 8%)",
	"--ansi-bg-bright-red": "color-mix(in srgb, hsl(0, calc(88% * var(--saturation-factor)), 62%) 92%, color-mix(in srgb, hsl(258, calc(10% * var(--saturation-factor)), 14.15%) 92%, hsl(258, calc(10% * var(--saturation-factor)), 5%) 8%) 8%)",
	"--ansi-bg-bright-white": "color-mix(in srgb, hsl(0, 0%, 100%) 92%, color-mix(in srgb, hsl(258, calc(10% * var(--saturation-factor)), 14.15%) 92%, hsl(258, calc(10% * var(--saturation-factor)), 5%) 8%) 8%)",
	"--ansi-bg-bright-yellow": "color-mix(in srgb, hsl(41, calc(53% * var(--saturation-factor)), 67%) 92%, color-mix(in srgb, hsl(258, calc(10% * var(--saturation-factor)), 14.15%) 92%, hsl(258, calc(10% * var(--saturation-factor)), 5%) 8%) 8%)",
	"--ansi-bg-cyan": "color-mix(in srgb, hsl(168, calc(53% * var(--saturation-factor)), 55%) 88%, color-mix(in srgb, hsl(258, calc(10% * var(--saturation-factor)), 14.15%) 92%, hsl(258, calc(10% * var(--saturation-factor)), 5%) 8%) 12%)",
	"--ansi-bg-green": "color-mix(in srgb, hsl(99, calc(29% * var(--saturation-factor)), 47%) 88%, color-mix(in srgb, hsl(258, calc(10% * var(--saturation-factor)), 14.15%) 92%, hsl(258, calc(10% * var(--saturation-factor)), 5%) 8%) 12%)",
	"--ansi-bg-magenta": "color-mix(in srgb, hsl(305, calc(35% * var(--saturation-factor)), 65%) 88%, color-mix(in srgb, hsl(258, calc(10% * var(--saturation-factor)), 14.15%) 92%, hsl(258, calc(10% * var(--saturation-factor)), 5%) 8%) 12%)",
	"--ansi-bg-red": "color-mix(in srgb, hsl(0, calc(88% * var(--saturation-factor)), 62%) 88%, color-mix(in srgb, hsl(258, calc(10% * var(--saturation-factor)), 14.15%) 92%, hsl(258, calc(10% * var(--saturation-factor)), 5%) 8%) 12%)",
	"--ansi-bg-white": "color-mix(in srgb, hsl(0, 0%, 83%) 88%, color-mix(in srgb, hsl(258, calc(10% * var(--saturation-factor)), 14.15%) 92%, hsl(258, calc(10% * var(--saturation-factor)), 5%) 8%) 12%)",
	"--ansi-bg-yellow": "color-mix(in srgb, hsl(41, calc(53% * var(--saturation-factor)), 67%) 88%, color-mix(in srgb, hsl(258, calc(10% * var(--saturation-factor)), 14.15%) 92%, hsl(258, calc(10% * var(--saturation-factor)), 5%) 8%) 12%)",
	"--ansi-fg-black": "color-mix(in srgb, hsl(0, 0%, 12%) 72%, hsl(258, calc(10% * var(--saturation-factor)), 70.4%) 28%)",
	"--ansi-fg-blue": "color-mix(in srgb, hsl(207, calc(61% * var(--saturation-factor)), 59%) 92%, color-mix(in srgb, hsl(258, calc(10% * var(--saturation-factor)), 90.36%) 82%, hsl(340, calc(50% * var(--saturation-factor)), 90%) 18%) 8%)",
	"--ansi-fg-bright-black": "color-mix(in srgb, hsl(0, 0%, 50%) 86%, hsl(258, calc(10% * var(--saturation-factor)), 70.4%) 14%)",
	"--ansi-fg-bright-blue": "color-mix(in srgb, hsl(207, calc(61% * var(--saturation-factor)), 59%) 94%, hsl(258, calc(10% * var(--saturation-factor)), 96%) 6%)",
	"--ansi-fg-bright-cyan": "color-mix(in srgb, hsl(168, calc(53% * var(--saturation-factor)), 55%) 94%, hsl(258, calc(10% * var(--saturation-factor)), 96%) 6%)",
	"--ansi-fg-bright-green": "color-mix(in srgb, hsl(99, calc(29% * var(--saturation-factor)), 47%) 88%, hsl(258, calc(10% * var(--saturation-factor)), 96%) 12%)",
	"--ansi-fg-bright-magenta": "color-mix(in srgb, hsl(305, calc(35% * var(--saturation-factor)), 65%) 94%, hsl(258, calc(10% * var(--saturation-factor)), 96%) 6%)",
	"--ansi-fg-bright-red": "color-mix(in srgb, hsl(0, calc(88% * var(--saturation-factor)), 62%) 94%, hsl(258, calc(10% * var(--saturation-factor)), 96%) 6%)",
	"--ansi-fg-bright-white": "hsl(258, calc(10% * var(--saturation-factor)), 96%)",
	"--ansi-fg-bright-yellow": "color-mix(in srgb, hsl(41, calc(53% * var(--saturation-factor)), 67%) 94%, hsl(258, calc(10% * var(--saturation-factor)), 96%) 6%)",
	"--ansi-fg-cyan": "color-mix(in srgb, hsl(168, calc(53% * var(--saturation-factor)), 55%) 92%, color-mix(in srgb, hsl(258, calc(10% * var(--saturation-factor)), 90.36%) 82%, hsl(340, calc(50% * var(--saturation-factor)), 90%) 18%) 8%)",
	"--ansi-fg-green": "color-mix(in srgb, hsl(99, calc(29% * var(--saturation-factor)), 47%) 92%, color-mix(in srgb, hsl(258, calc(10% * var(--saturation-factor)), 90.36%) 82%, hsl(340, calc(50% * var(--saturation-factor)), 90%) 18%) 8%)",
	"--ansi-fg-magenta": "color-mix(in srgb, hsl(305, calc(35% * var(--saturation-factor)), 65%) 92%, color-mix(in srgb, hsl(258, calc(10% * var(--saturation-factor)), 90.36%) 82%, hsl(340, calc(50% * var(--saturation-factor)), 90%) 18%) 8%)",
	"--ansi-fg-red": "color-mix(in srgb, hsl(0, calc(88% * var(--saturation-factor)), 62%) 92%, color-mix(in srgb, hsl(258, calc(10% * var(--saturation-factor)), 90.36%) 82%, hsl(340, calc(50% * var(--saturation-factor)), 90%) 18%) 8%)",
	"--ansi-fg-white": "color-mix(in srgb, hsl(0, 0%, 83%) 88%, hsl(258, calc(10% * var(--saturation-factor)), 90.36%) 12%)",
	"--ansi-fg-yellow": "color-mix(in srgb, hsl(41, calc(53% * var(--saturation-factor)), 67%) 92%, color-mix(in srgb, hsl(258, calc(10% * var(--saturation-factor)), 90.36%) 82%, hsl(340, calc(50% * var(--saturation-factor)), 90%) 18%) 8%)",
	"--ansi-inverse-bg": "color-mix(in srgb, hsl(258, calc(10% * var(--saturation-factor)), 90.36%) 82%, hsl(340, calc(50% * var(--saturation-factor)), 90%) 18%)",
	"--ansi-inverse-text": "color-mix(in srgb, hsl(258, calc(10% * var(--saturation-factor)), 14.15%) 92%, hsl(258, calc(10% * var(--saturation-factor)), 5%) 8%)",
	"--avatar-stack-extra-height": "0.375rem",
	"--background-channel-header": "hsl(258, calc(10% * var(--saturation-factor)), 15.72%)",
	"--background-header-primary": "hsl(258, calc(10% * var(--saturation-factor)), 19.25%)",
	"--background-header-primary-hover": "hsl(258, calc(10% * var(--saturation-factor)), 23.57%)",
	"--background-header-secondary": "hsl(258, calc(10% * var(--saturation-factor)), 19.25%)",
	"--background-modifier-accent": "hsla(258, calc(13% * var(--saturation-factor)), 80%, 0.15)",
	"--background-modifier-accent-focus": "hsla(258, calc(13% * var(--saturation-factor)), 80%, 0.22)",
	"--background-modifier-hover": "hsla(258, calc(10% * var(--saturation-factor)), 100%, 0.05)",
	"--background-modifier-selected": "hsla(258, calc(10% * var(--saturation-factor)), 100%, 0.1)",
	"--background-primary": "hsl(258, calc(10% * var(--saturation-factor)), 5%)",
	"--background-secondary": "hsl(258, calc(10% * var(--saturation-factor)), 10.59%)",
	"--background-secondary-alt": "hsl(258, calc(10% * var(--saturation-factor)), 14.15%)",
	"--background-secondary-lighter": "hsl(258, calc(10% * var(--saturation-factor)), 12.44%)",
	"--background-tertiary": "hsl(258, calc(10% * var(--saturation-factor)), 17.16%)",
	"--background-textarea": "hsl(258, calc(10% * var(--saturation-factor)), 14.69%)",
	"--bg-active": "hsla(258, calc(10% * var(--saturation-factor)), 100%, 0.1)",
	"--bg-blockquote": "hsl(258, calc(10% * var(--saturation-factor)), 14.15%)",
	"--bg-code": "color-mix(in srgb, hsl(258, calc(10% * var(--saturation-factor)), 14.15%) 88%, hsl(258, calc(10% * var(--saturation-factor)), 17.16%) 12%)",
	"--bg-code-block": "color-mix(in srgb, hsl(258, calc(10% * var(--saturation-factor)), 14.15%) 92%, hsl(258, calc(10% * var(--saturation-factor)), 5%) 8%)",
	"--bg-hover": "hsla(258, calc(10% * var(--saturation-factor)), 100%, 0.05)",
	"--bg-primary": "hsl(258, calc(10% * var(--saturation-factor)), 5%)",
	"--bg-secondary": "hsl(258, calc(10% * var(--saturation-factor)), 10.59%)",
	"--bg-table-header": "hsl(258, calc(10% * var(--saturation-factor)), 17.16%)",
	"--bg-table-row-even": "hsl(258, calc(10% * var(--saturation-factor)), 10.59%)",
	"--bg-table-row-odd": "hsl(258, calc(10% * var(--saturation-factor)), 5%)",
	"--bg-tertiary": "hsl(258, calc(10% * var(--saturation-factor)), 17.16%)",
	"--border-color": "hsla(258, calc(10% * var(--saturation-factor)), 50%, 0.2)",
	"--border-color-focus": "hsla(198, calc(92% * var(--saturation-factor)), 70%, 0.45)",
	"--border-color-hover": "hsla(258, calc(10% * var(--saturation-factor)), 50%, 0.3)",
	"--brand-primary": "hsl(242, calc(70% * var(--saturation-factor)), 55%)",
	"--brand-primary-fill": "hsl(0, 0%, 100%)",
	"--brand-primary-foreground": "hsl(242, calc(70% * var(--saturation-factor)), 55%)",
	"--brand-primary-light": "hsl(242, calc(100% * var(--saturation-factor)), 84%)",
	"--brand-primary-light-fill": "hsl(0, 0%, 100%)",
	"--brand-primary-pressed": "color-mix(in srgb, hsl(242, calc(70% * var(--saturation-factor)), 55%) 90%, hsl(0, 0%, 0%))",
	"--brand-primary-shade": "hsl(0, 0%, 0%)",
	"--brand-secondary": "hsl(242, calc(60% * var(--saturation-factor)), 49%)",
	"--brand-tint": "color-mix(in srgb, var(--brand-primary) 36%, var(--background-secondary) 64%)",
	"--brand-tint-border": "var(--brand-primary)",
	"--brand-tint-hover": "color-mix(in srgb, var(--brand-primary) 48%, var(--background-secondary) 52%)",
	"--button-danger-active-fill": "hsl(359, calc(65% * var(--saturation-factor)), 45%)",
	"--button-danger-fill": "hsl(359, calc(70% * var(--saturation-factor)), 54%)",
	"--button-danger-outline-active-border": "transparent",
	"--button-danger-outline-active-fill": "hsl(359, calc(65% * var(--saturation-factor)), 48%)",
	"--button-danger-outline-border": "1px solid hsl(359, calc(70% * var(--saturation-factor)), 54%)",
	"--button-danger-outline-text": "hsl(0, 0%, 100%)",
	"--button-danger-text": "hsl(0, 0%, 100%)",
	"--button-ghost-text": "hsl(0, 0%, 100%)",
	"--button-inverted-fill": "hsl(0, 0%, 100%)",
	"--button-inverted-text": "hsl(0, 0%, 0%)",
	"--button-outline-active-border": "1px solid hsla(0, 0%, 100%, 0.4)",
	"--button-outline-active-fill": "hsla(0, 0%, 100%, 0.15)",
	"--button-outline-border": "1px solid hsla(0, 0%, 100%, 0.3)",
	"--button-outline-text": "hsl(0, 0%, 100%)",
	"--button-primary-active-fill": "hsl(136, calc(60% * var(--saturation-factor)), 38%)",
	"--button-primary-fill": "hsl(139, calc(55% * var(--saturation-factor)), 44%)",
	"--button-primary-text": "hsl(0, 0%, 100%)",
	"--button-secondary-active-fill": "hsla(0, 0%, 100%, 0.15)",
	"--button-secondary-active-text": "hsl(0, 0%, 100%)",
	"--button-secondary-fill": "hsla(0, 0%, 100%, 0.1)",
	"--button-secondary-text": "hsl(0, 0%, 100%)",
	"--channel-header-action-icon-size": "1.5rem",
	"--channel-header-action-size": "2rem",
	"--channel-header-action-size-mobile": "2.5rem",
	"--channel-header-actions-gap": "0.5rem",
	"--channel-header-back-button-gap": "0.75rem",
	"--channel-header-back-button-size": "2rem",
	"--channel-header-back-icon-size": "1.5rem",
	"--channel-header-caret-gap": "0.25rem",
	"--channel-header-caret-size": "1rem",
	"--channel-header-gap": "1rem",
	"--channel-header-icon-size": "1.5rem",
	"--channel-header-name-gap": "0.75rem",
	"--channel-header-name-gap-group-dm": "0.5rem",
	"--channel-header-padding-inline": "1rem",
	"--channel-header-topic-divider-gap": "0.5rem",
	"--chat-horizontal-padding": "1rem",
	"--chat-horizontal-padding-default": "1rem",
	"--chat-mobile-horizontal-padding": "0.75rem",
	"--code-block-bg": "color-mix(in srgb, hsl(258, calc(10% * var(--saturation-factor)), 14.15%) 92%, hsl(258, calc(10% * var(--saturation-factor)), 5%) 8%)",
	"--code-block-border": "color-mix(in srgb, hsla(258, calc(10% * var(--saturation-factor)), 50%, 0.2) 90%, color-mix(in srgb, hsl(258, calc(10% * var(--saturation-factor)), 90.36%) 82%, hsl(340, calc(50% * var(--saturation-factor)), 90%) 18%) 10%)",
	"--code-block-highlight": "color-mix(in srgb, hsl(258, calc(10% * var(--saturation-factor)), 96%) 10%, transparent)",
	"--code-inline-bg": "color-mix(in srgb, hsl(258, calc(10% * var(--saturation-factor)), 14.15%) 88%, hsl(258, calc(10% * var(--saturation-factor)), 17.16%) 12%)",
	"--code-muted": "color-mix(in srgb, color-mix(in srgb, hsl(258, calc(10% * var(--saturation-factor)), 90.36%) 82%, hsl(340, calc(50% * var(--saturation-factor)), 90%) 18%) 42%, hsl(258, calc(10% * var(--saturation-factor)), 70.4%) 58%)",
	"--code-text": "color-mix(in srgb, hsl(258, calc(10% * var(--saturation-factor)), 90.36%) 82%, hsl(340, calc(50% * var(--saturation-factor)), 90%) 18%)",
	"--composer-action-gap": "0.25rem",
	"--composer-box-inset": "max(0rem, calc((calc(3.625rem + 0.375rem * 2) - 3.625rem) / 2))",
	"--composer-box-inset-inline": "min( 0.375rem, 1rem )",
	"--composer-box-padding-inline": "max( 0rem, calc(1rem - min( 0.375rem, 1rem )) )",
	"--composer-mobile-box-height": "3rem",
	"--composer-mobile-padding-y": "max( 0rem, calc((3rem - 2rem) / 2) )",
	"--composer-status-line-height": "1.125rem",
	"--composer-status-row-height": "1.5rem",
	"--composer-status-safe-area": "calc(1.5rem + 0.5rem)",
	"--composer-status-safe-gap": "0.5rem",
	"--composer-surface-color": "hsl(258, calc(10% * var(--saturation-factor)), 12.44%)",
	"--content-padding": "1rem",
	"--content-padding-lg": "1.5rem",
	"--content-padding-sm": "0.75rem",
	"--control-button-active-bg": "hsl(258, calc(10% * var(--saturation-factor)), 24%)",
	"--control-button-active-text": "hsl(258, calc(10% * var(--saturation-factor)), 96%)",
	"--control-button-danger-hover-bg": "hsl(1, calc(77% * var(--saturation-factor)), 20%)",
	"--control-button-danger-text": "hsl(1, calc(77% * var(--saturation-factor)), 60%)",
	"--control-button-hover-bg": "hsl(258, calc(10% * var(--saturation-factor)), 22%)",
	"--control-button-hover-text": "hsl(258, calc(10% * var(--saturation-factor)), 96%)",
	"--control-button-normal-bg": "transparent",
	"--control-button-normal-text": "hsl(258, calc(10% * var(--saturation-factor)), 81.42%)",
	"--count-indicator-gap": "0.25rem",
	"--discovery-card-description-min-height": "5.25rem",
	"--dm-sidebar-mobile-header-height": "3.5rem",
	"--emoji-size-emoji": "1.5em",
	"--emoji-size-jumbo-emoji": "3rem",
	"--floating-surface-ring-color": "color-mix(in srgb, hsla(258, calc(13% * var(--saturation-factor)), 80%, 0.15) 20%, transparent)",
	"--floating-surface-ring-color-strong": "color-mix(in srgb, hsla(258, calc(13% * var(--saturation-factor)), 80%, 0.15) 45%, transparent)",
	"--focus-primary": "#00b0f4",
	"--folder-radius": "calc(3rem * 0.3)",
	"--font-fallback-mono": "'Noto Sans Mono', 'Fluxer Sans SC', 'Fluxer Sans TC', 'Fluxer Sans JP', 'Fluxer Sans KR', 'Apple Color Emoji', 'Segoe UI Emoji', 'Noto Color Emoji', 'Fluxer Fallback', 'Fluxer Symbols', 'Fluxer Math', 'Noto Sans', 'Nirmala UI', 'Noto Sans Bengali', 'Noto Sans Tamil', 'Noto Sans Telugu', 'Noto Sans Kannada', 'Noto Sans Malayalam', 'Noto Sans Gujarati', 'Noto Sans Gurmukhi', 'Noto Sans Oriya', 'Noto Sans Sinhala', 'Noto Sans Khmer', 'Noto Sans Lao', 'Noto Sans Myanmar', 'Noto Sans Tibetan', 'Noto Sans Armenian', 'Noto Sans Georgian', 'Noto Sans Ethiopic', 'Noto Sans Cherokee', 'Noto Sans Canadian Aboriginal', 'Noto Sans Mongolian', 'Noto Sans Vai', 'Noto Sans NKo', 'Noto Sans Adlam', 'Noto Sans Yi', 'Noto Sans Osage', 'Noto Sans Thaana', 'Noto Sans CJK SC', 'Noto Sans CJK TC', 'Noto Sans CJK JP', 'Noto Sans CJK KR', 'Segoe UI Symbol', 'Segoe UI Historic', 'Apple Symbols', 'Noto Sans Symbols', 'Noto Sans Symbols 2', 'Noto Sans Math', 'Cambria Math'",
	"--font-fallback-sans": "'Apple Color Emoji', 'Segoe UI Emoji', 'Noto Color Emoji', 'Fluxer Fallback', 'Fluxer Symbols', 'Fluxer Math', 'Noto Sans', 'Nirmala UI', 'Noto Sans Bengali', 'Noto Sans Tamil', 'Noto Sans Telugu', 'Noto Sans Kannada', 'Noto Sans Malayalam', 'Noto Sans Gujarati', 'Noto Sans Gurmukhi', 'Noto Sans Oriya', 'Noto Sans Sinhala', 'Noto Sans Khmer', 'Noto Sans Lao', 'Noto Sans Myanmar', 'Noto Sans Tibetan', 'Noto Sans Armenian', 'Noto Sans Georgian', 'Noto Sans Ethiopic', 'Noto Sans Cherokee', 'Noto Sans Canadian Aboriginal', 'Noto Sans Mongolian', 'Noto Sans Vai', 'Noto Sans NKo', 'Noto Sans Adlam', 'Noto Sans Yi', 'Noto Sans Osage', 'Noto Sans Thaana', 'Noto Sans CJK SC', 'Noto Sans CJK TC', 'Noto Sans CJK JP', 'Noto Sans CJK KR', 'Segoe UI Symbol', 'Segoe UI Historic', 'Apple Symbols', 'Noto Sans Symbols', 'Noto Sans Symbols 2', 'Noto Sans Math', 'Cambria Math'",
	"--font-keybind": "-apple-system, BlinkMacSystemFont, 'Fluxer Sans', 'Fluxer Sans Arabic', 'Fluxer Sans Hebrew', 'Fluxer Sans Devanagari', 'Fluxer Sans Thai Looped', 'Fluxer Sans SC', 'Fluxer Sans TC', 'Fluxer Sans JP', 'Fluxer Sans KR', system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Apple Color Emoji', 'Segoe UI Emoji', 'Noto Color Emoji', 'Fluxer Fallback', 'Fluxer Symbols', 'Fluxer Math', 'Noto Sans', 'Nirmala UI', 'Noto Sans Bengali', 'Noto Sans Tamil', 'Noto Sans Telugu', 'Noto Sans Kannada', 'Noto Sans Malayalam', 'Noto Sans Gujarati', 'Noto Sans Gurmukhi', 'Noto Sans Oriya', 'Noto Sans Sinhala', 'Noto Sans Khmer', 'Noto Sans Lao', 'Noto Sans Myanmar', 'Noto Sans Tibetan', 'Noto Sans Armenian', 'Noto Sans Georgian', 'Noto Sans Ethiopic', 'Noto Sans Cherokee', 'Noto Sans Canadian Aboriginal', 'Noto Sans Mongolian', 'Noto Sans Vai', 'Noto Sans NKo', 'Noto Sans Adlam', 'Noto Sans Yi', 'Noto Sans Osage', 'Noto Sans Thaana', 'Noto Sans CJK SC', 'Noto Sans CJK TC', 'Noto Sans CJK JP', 'Noto Sans CJK KR', 'Segoe UI Symbol', 'Segoe UI Historic', 'Apple Symbols', 'Noto Sans Symbols', 'Noto Sans Symbols 2', 'Noto Sans Math', 'Cambria Math', sans-serif",
	"--font-mono": "'Fluxer Mono', 'Menlo', 'Monaco', 'Courier New', 'Noto Sans Mono', 'Fluxer Sans SC', 'Fluxer Sans TC', 'Fluxer Sans JP', 'Fluxer Sans KR', 'Apple Color Emoji', 'Segoe UI Emoji', 'Noto Color Emoji', 'Fluxer Fallback', 'Fluxer Symbols', 'Fluxer Math', 'Noto Sans', 'Nirmala UI', 'Noto Sans Bengali', 'Noto Sans Tamil', 'Noto Sans Telugu', 'Noto Sans Kannada', 'Noto Sans Malayalam', 'Noto Sans Gujarati', 'Noto Sans Gurmukhi', 'Noto Sans Oriya', 'Noto Sans Sinhala', 'Noto Sans Khmer', 'Noto Sans Lao', 'Noto Sans Myanmar', 'Noto Sans Tibetan', 'Noto Sans Armenian', 'Noto Sans Georgian', 'Noto Sans Ethiopic', 'Noto Sans Cherokee', 'Noto Sans Canadian Aboriginal', 'Noto Sans Mongolian', 'Noto Sans Vai', 'Noto Sans NKo', 'Noto Sans Adlam', 'Noto Sans Yi', 'Noto Sans Osage', 'Noto Sans Thaana', 'Noto Sans CJK SC', 'Noto Sans CJK TC', 'Noto Sans CJK JP', 'Noto Sans CJK KR', 'Segoe UI Symbol', 'Segoe UI Historic', 'Apple Symbols', 'Noto Sans Symbols', 'Noto Sans Symbols 2', 'Noto Sans Math', 'Cambria Math', monospace",
	"--font-sans": "'Fluxer Sans', 'Fluxer Sans Arabic', 'Fluxer Sans Hebrew', 'Fluxer Sans Devanagari', 'Fluxer Sans Thai Looped', 'Fluxer Sans SC', 'Fluxer Sans TC', 'Fluxer Sans JP', 'Fluxer Sans KR', system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Apple Color Emoji', 'Segoe UI Emoji', 'Noto Color Emoji', 'Fluxer Fallback', 'Fluxer Symbols', 'Fluxer Math', 'Noto Sans', 'Nirmala UI', 'Noto Sans Bengali', 'Noto Sans Tamil', 'Noto Sans Telugu', 'Noto Sans Kannada', 'Noto Sans Malayalam', 'Noto Sans Gujarati', 'Noto Sans Gurmukhi', 'Noto Sans Oriya', 'Noto Sans Sinhala', 'Noto Sans Khmer', 'Noto Sans Lao', 'Noto Sans Myanmar', 'Noto Sans Tibetan', 'Noto Sans Armenian', 'Noto Sans Georgian', 'Noto Sans Ethiopic', 'Noto Sans Cherokee', 'Noto Sans Canadian Aboriginal', 'Noto Sans Mongolian', 'Noto Sans Vai', 'Noto Sans NKo', 'Noto Sans Adlam', 'Noto Sans Yi', 'Noto Sans Osage', 'Noto Sans Thaana', 'Noto Sans CJK SC', 'Noto Sans CJK TC', 'Noto Sans CJK JP', 'Noto Sans CJK KR', 'Segoe UI Symbol', 'Segoe UI Historic', 'Apple Symbols', 'Noto Sans Symbols', 'Noto Sans Symbols 2', 'Noto Sans Math', 'Cambria Math', sans-serif",
	"--font-sans-primary": "'Fluxer Sans'",
	"--font-size": "1rem",
	"--font-size-xs": "0.75rem",
	"--footer-box-height": "3.625rem",
	"--footer-box-inner-inset": "0.5rem",
	"--footer-box-inset": "0.375rem",
	"--footer-box-inset-inline": "0.375rem",
	"--footer-box-padding-y": "max(0rem, calc((3.625rem - 2rem) / 2))",
	"--footer-box-radius": "0.5rem",
	"--footer-row-height": "calc(3.625rem + 0.375rem * 2)",
	"--form-surface-background": "hsl(258, calc(10% * var(--saturation-factor)), 17.16%)",
	"--friend-row-action-gap": "0.5rem",
	"--friend-row-action-size": "2.25rem",
	"--friend-row-avatar-size": "2.25rem",
	"--friend-row-content-gap": "0.75rem",
	"--friend-row-name-line-height": "1.25rem",
	"--friend-row-padding-block": "0.75rem",
	"--friend-row-padding-inline": "1rem",
	"--friend-row-separator-inset": "0 0.4rem 0 0.5rem",
	"--friend-row-separator-radius": "0.375rem",
	"--friend-row-subtext-line-height": "1rem",
	"--friend-row-subtext-offset": "-0.0625rem",
	"--guild-badge-surface": "hsl(258, calc(10% * var(--saturation-factor)), 10.59%)",
	"--guild-folder-expanded-surface-size": "3rem",
	"--guild-icon-gap": "0.5rem",
	"--guild-icon-size": "2.75rem",
	"--guild-list-divider-base-gap": "0.375rem",
	"--guild-list-divider-line-size": "0.125rem",
	"--guild-list-foreground": "hsl(258, calc(10% * var(--saturation-factor)), 16.7%)",
	"--guild-list-indicator-bar-width": "0.35rem",
	"--guild-list-indicator-inset": "-0.15rem",
	"--guild-list-indicator-track-width": "0.5rem",
	"--guild-list-item-box-size": "3rem",
	"--guild-list-item-gap": "0.375rem",
	"--guild-list-item-target-half-extra": "calc((calc(3rem + 0.375rem) - 3rem) / 2)",
	"--guild-list-item-target-size": "calc(3rem + 0.375rem)",
	"--guild-members-columns": "minmax(15rem, 2.2fr) minmax(7.5rem, 1fr) minmax(7.5rem, 1fr) minmax(9.375rem, 1.15fr) minmax(10rem, 1.35fr) 4.5rem",
	"--guild-members-columns-selectable": "2.75rem minmax(15rem, 2.2fr) minmax(7.5rem, 1fr) minmax(7.5rem, 1fr) minmax(9.375rem, 1.15fr) minmax(10rem, 1.35fr) 4.5rem",
	"--guild-members-min-width": "calc(15rem + 7.5rem + 7.5rem + 9.375rem + 10rem + 4.5rem)",
	"--guild-members-min-width-selectable": "calc(2.75rem + calc(15rem + 7.5rem + 7.5rem + 9.375rem + 10rem + 4.5rem))",
	"--guild-members-select-column-width": "2.75rem",
	"--guild-members-table-row-border-width": "0.0625rem",
	"--guild-members-table-row-min-height": "3rem",
	"--guilds-layout-item-bg": "hsl(258, calc(10% * var(--saturation-factor)), 16.7%)",
	"--input-container-min-height": "calc(3.625rem + 0.375rem * 2)",
	"--input-container-padding": "0.625rem",
	"--input-wrapper-padding-bottom": "0.5rem",
	"--input-wrapper-padding-x": "0.5rem",
	"--interactive-active": "color-mix( in oklab, hsl(0, calc(0% * var(--saturation-factor)), 100%) 100%, hsl(245, calc(100% * var(--saturation-factor)), 80%) 40% )",
	"--interactive-muted": "color-mix( in oklab, hsl(228, calc(10% * var(--saturation-factor)), 35%) 100%, hsl(245, calc(100% * var(--saturation-factor)), 80%) 40% )",
	"--invite-verified-icon-color": "hsl(0, 0%, 98%)",
	"--layout-gap": "1rem",
	"--layout-gap-lg": "1.5rem",
	"--layout-gap-sm": "0.5rem",
	"--layout-guild-list-width": "4.5rem",
	"--layout-header-height": "3.5rem",
	"--layout-header-height-mobile": "4rem",
	"--layout-header-popout-width": "calc(20rem - (1rem * 2))",
	"--layout-member-list-width": "16.5rem",
	"--layout-mobile-bottom-nav-reserved-height": "0px",
	"--layout-sidebar-width": "20rem",
	"--layout-user-area-height": "3.625rem",
	"--layout-user-area-reserved-height": "0px",
	"--layout-voice-connection-height": "0px",
	"--link-decoration": "none",
	"--list-row-min-height": "4.5rem",
	"--macos-traffic-light-inset": "78px",
	"--markup-everyone-border": "hsla(250, calc(80% * var(--saturation-factor)), 75%, 0.3)",
	"--markup-everyone-fill": "color-mix(in srgb, hsl(250, calc(80% * var(--saturation-factor)), 75%) 18%, transparent)",
	"--markup-everyone-text": "hsl(250, calc(80% * var(--saturation-factor)), 75%)",
	"--markup-here-border": "hsla(45, calc(90% * var(--saturation-factor)), 70%, 0.3)",
	"--markup-here-fill": "color-mix(in srgb, hsl(45, calc(90% * var(--saturation-factor)), 70%) 18%, transparent)",
	"--markup-here-text": "hsl(45, calc(90% * var(--saturation-factor)), 70%)",
	"--markup-interactive-hover-fill": "color-mix(in srgb, hsl(198, calc(92% * var(--saturation-factor)), 70%) 30%, transparent)",
	"--markup-interactive-hover-text": "hsl(198, calc(92% * var(--saturation-factor)), 70%)",
	"--markup-jump-link-fill": "color-mix(in srgb, hsl(198, calc(92% * var(--saturation-factor)), 70%) 12%, transparent)",
	"--markup-jump-link-hover-fill": "color-mix(in srgb, hsl(198, calc(92% * var(--saturation-factor)), 70%) 20%, transparent)",
	"--markup-jump-link-text": "hsl(198, calc(92% * var(--saturation-factor)), 70%)",
	"--markup-mention-border": "hsla(198, calc(92% * var(--saturation-factor)), 70%, 0.3)",
	"--markup-mention-fill": "color-mix(in srgb, hsl(198, calc(92% * var(--saturation-factor)), 70%) 20%, transparent)",
	"--markup-mention-text": "hsl(198, calc(92% * var(--saturation-factor)), 70%)",
	"--markup-restricted-inline-emoji-baseline-shift": "-0.18em",
	"--markup-restricted-inline-emoji-size": "1.25em",
	"--markup-restricted-inline-icon-baseline-shift": "-0.125em",
	"--markup-strikethrough-color": "currentColor",
	"--media-border-radius": "0.25rem",
	"--member-list-group-spacer-height": "0.25rem",
	"--member-list-item-content-gap": "0.625rem",
	"--member-list-item-content-height": "2rem",
	"--member-list-item-name-line-height": "1.25rem",
	"--member-list-item-padding-block": "0.25rem",
	"--member-list-item-padding-inline": "0.5rem",
	"--member-list-item-status-line-height": "0.875rem",
	"--member-list-row-gap": "0.125rem",
	"--member-list-scroller-padding-block-end": "1rem",
	"--member-list-scroller-padding-block-start": "0.25rem",
	"--member-list-scroller-padding-inline": "0.5rem",
	"--mention-badge-medium-size": "1.5rem",
	"--mention-badge-small-size": "1.25rem",
	"--message-action-bar-offset": "3rem",
	"--message-avatar-align-offset": "clamp(0px, calc((1.375rem * 2 - 2.5rem) / 2), 0.5rem)",
	"--message-avatar-size": "2.5rem",
	"--message-avatar-size-compact": "1rem",
	"--message-compact-container-margin": "calc(3.5rem + 0.25rem)",
	"--message-compact-gap": "0.25rem",
	"--message-compact-horizontal-padding": "min( 1rem, 1rem )",
	"--message-compact-indent": "calc(3.5rem + 0.25rem)",
	"--message-compact-markdown-alert-padding-block": "0.35rem",
	"--message-compact-markdown-alert-padding-inline": "0.75rem",
	"--message-compact-markdown-block-gap": "0.5rem",
	"--message-compact-markdown-blockquote-divider-margin-end": "0.35rem",
	"--message-compact-markdown-blockquote-gap": "0.25rem",
	"--message-compact-table-max-inline-size": "100%",
	"--message-compact-table-min-cell-width": "5rem",
	"--message-compact-text-indent-from-username": "2rem",
	"--message-compact-timestamp-width": "3.5rem",
	"--message-compact-username-gap": "0.45rem",
	"--message-container-gap": "0.25rem",
	"--message-container-padding-y": "0.125rem",
	"--message-edited-font-size": "0.75rem",
	"--message-edited-label-font-size": "0.625rem",
	"--message-failed-indicator-font-size": "0.75rem",
	"--message-failed-indicator-gap": "0.375rem",
	"--message-failed-opacity": "0.5",
	"--message-filler-padding-bottom": "0.75rem",
	"--message-group-spacing": "1rem",
	"--message-gutter": "0.75rem",
	"--message-highlight-bar-width": "0.125rem",
	"--message-icon-size-lg": "1.25rem",
	"--message-icon-size-md": "1rem",
	"--message-icon-size-sm": "0.875rem",
	"--message-line-height": "1.375rem",
	"--message-mention-bg": "rgb(234 197 50 / 0.1)",
	"--message-mention-bg-hover": "rgb(234 197 50 / 0.14)",
	"--message-mention-color": "rgb(234 197 50)",
	"--message-mobile-margin": "0.75rem",
	"--message-preview-card-background": "hsla(0, 0%, 100%, 0.022)",
	"--message-preview-card-border": "hsla(0, 0%, 100%, 0.07)",
	"--message-preview-card-divider": "hsla(0, 0%, 100%, 0.05)",
	"--message-replied-username-opacity": "0.64",
	"--message-reply-bg": "rgb(59 130 246 / 0.1)",
	"--message-reply-color": "rgb(59 130 246)",
	"--message-reply-font-size": "0.875rem",
	"--message-reply-height": "1.125rem",
	"--message-reply-spacing": "0.25rem",
	"--message-reply-spine-radius": "0.375rem",
	"--message-reply-spine-width": "0.125rem",
	"--message-search-bar-height": "2.25rem",
	"--message-search-bar-icon-gap": "0.5rem",
	"--message-search-bar-icon-size": "1rem",
	"--message-search-bar-width": "15.25rem",
	"--message-sending-link-opacity": "0.7",
	"--message-sending-opacity": "0.5",
	"--message-spacing-y": "0.125rem",
	"--message-timestamp-color": "hsl(258, calc(10% * var(--saturation-factor)), 81.42%)",
	"--message-timestamp-compact-font-size": "0.6875rem",
	"--message-timestamp-compact-height": "1.25rem",
	"--message-timestamp-font-size": "0.75rem",
	"--message-transition-highlight": "320ms cubic-bezier(0.32, 0.72, 0, 1)",
	"--message-typing-avatar-margin": "0.2rem",
	"--message-typing-gap": "0.35rem",
	"--message-typing-pill-gap": "0.2rem",
	"--message-typing-pill-padding": "0.45rem",
	"--message-typing-text-font-size": "0.6875rem",
	"--message-unknown-warning-color": "#ff9933",
	"--messages-bottom-clearance": "1.5rem",
	"--mobile-bottom-nav-height": "3.75rem",
	"--native-titlebar-height": "32px",
	"--outline-frame-border-width": "0.0625rem",
	"--outline-frame-radius-native": "clamp(0.5rem, 1.2vw, 0.875rem)",
	"--panel-control-bg": "color-mix( in srgb, hsl(258, calc(10% * var(--saturation-factor)), 14.15%) 90%, hsl(258, calc(10% * var(--saturation-factor)), 2%) 10% )",
	"--panel-control-border": "hsla(258, calc(30% * var(--saturation-factor)), 65%, 0.45)",
	"--panel-control-divider": "hsla(258, calc(30% * var(--saturation-factor)), 55%, 0.35)",
	"--panel-control-highlight": "hsla(0, 0%, 100%, 0.04)",
	"--plutonium": "hsl(242, calc(70% * var(--saturation-factor)), 55%)",
	"--plutonium-hover": "hsl(242, calc(60% * var(--saturation-factor)), 49%)",
	"--plutonium-icon": "hsl(38, calc(92% * var(--saturation-factor)), 50%)",
	"--plutonium-text": "hsl(0, 0%, 98%)",
	"--radius-2xl": "1rem",
	"--radius-full": "624.9375rem",
	"--radius-lg": "0.5rem",
	"--radius-md": "0.375rem",
	"--radius-sm": "0.25rem",
	"--radius-xl": "0.75rem",
	"--saturation-factor": "1",
	"--scrollbar-thumb-bg": "rgba(121, 122, 124, 0.4)",
	"--scrollbar-thumb-bg-hover": "rgba(121, 122, 124, 0.7)",
	"--scrollbar-track-bg": "transparent",
	"--scroller-spacer-height": "1.75rem",
	"--shadow-lg": "0 4px 8px rgba(0, 0, 0, 0.15), 0 2px 4px rgba(0, 0, 0, 0.1)",
	"--shadow-md": "0 2px 4px rgba(0, 0, 0, 0.15), 0 1px 2px rgba(0, 0, 0, 0.1)",
	"--shadow-sm": "0 1px 2px rgba(0, 0, 0, 0.1)",
	"--shadow-xl": "0 10px 20px rgba(0, 0, 0, 0.15), 0 4px 8px rgba(0, 0, 0, 0.1)",
	"--skeleton-chrome-border": "0.0625rem solid color-mix(in srgb, hsla(258, calc(13% * var(--saturation-factor)), 80%, 0.15) 25%, transparent)",
	"--skeleton-chrome-border-color": "color-mix(in srgb, hsla(258, calc(13% * var(--saturation-factor)), 80%, 0.15) 25%, transparent)",
	"--skeleton-opacity-default": "0.45",
	"--skeleton-opacity-muted": "0.35",
	"--skeleton-opacity-strong": "0.55",
	"--slowmode-indicator-height": "1rem",
	"--spacing-0": "0px",
	"--spacing-1": "0.25rem",
	"--spacing-1-5": "0.375rem",
	"--spacing-10": "2.5rem",
	"--spacing-12": "3rem",
	"--spacing-16": "4rem",
	"--spacing-2": "0.5rem",
	"--spacing-20": "5rem",
	"--spacing-24": "6rem",
	"--spacing-3": "0.75rem",
	"--spacing-4": "1rem",
	"--spacing-5": "1.25rem",
	"--spacing-6": "1.5rem",
	"--spacing-8": "2rem",
	"--spoiler-border-radius": "0.375rem",
	"--spoiler-overlay-color": "rgba(0, 0, 0, 0.2)",
	"--spoiler-overlay-hover-color": "rgba(0, 0, 0, 0.3)",
	"--status-danger": "hsl(1, calc(77% * var(--saturation-factor)), 55%)",
	"--status-dnd": "hsl(0, calc(84% * var(--saturation-factor)), 60%)",
	"--status-idle": "hsl(45, calc(93% * var(--saturation-factor)), 50%)",
	"--status-offline": "hsl(218, calc(11% * var(--saturation-factor)), 65%)",
	"--status-online": "hsl(152, calc(72% * var(--saturation-factor)), 40%)",
	"--status-warning": "hsl(45, calc(93% * var(--saturation-factor)), 50%)",
	"--surface-interactive-hover-bg": "hsla(258, calc(10% * var(--saturation-factor)), 100%, 0.05)",
	"--surface-interactive-selected-bg": "hsla(258, calc(10% * var(--saturation-factor)), 100%, 0.1)",
	"--surface-interactive-selected-color": "hsl(258, calc(10% * var(--saturation-factor)), 96%)",
	"--system-message-icon-opacity": "0.6",
	"--system-message-icon-size": "1.125rem",
	"--text-chat": "hsl(258, calc(10% * var(--saturation-factor)), 93.67%)",
	"--text-chat-muted": "hsl(258, calc(10% * var(--saturation-factor)), 81.42%)",
	"--text-code": "color-mix(in srgb, hsl(258, calc(10% * var(--saturation-factor)), 90.36%) 82%, hsl(340, calc(50% * var(--saturation-factor)), 90%) 18%)",
	"--text-link": "hsl(198, calc(92% * var(--saturation-factor)), 70%)",
	"--text-on-brand-primary": "hsl(0, 0%, 98%)",
	"--text-on-brand-primary-light": "hsl(0, 0%, 98%)",
	"--text-on-brand-tint": "var(--text-on-brand-primary)",
	"--text-on-dark": "hsl(0, 0%, 98%)",
	"--text-primary": "hsl(258, calc(10% * var(--saturation-factor)), 96%)",
	"--text-primary-muted": "hsl(258, calc(10% * var(--saturation-factor)), 81.42%)",
	"--text-secondary": "hsl(258, calc(10% * var(--saturation-factor)), 90.36%)",
	"--text-selection": "hsla(198, calc(92% * var(--saturation-factor)), 70%, 0.35)",
	"--text-tertiary": "hsl(258, calc(10% * var(--saturation-factor)), 70.4%)",
	"--text-tertiary-muted": "hsl(258, calc(10% * var(--saturation-factor)), 62.88%)",
	"--text-tertiary-secondary": "hsl(258, calc(10% * var(--saturation-factor)), 60%)",
	"--text-warning": "hsl(45, calc(93% * var(--saturation-factor)), 55%)",
	"--textarea-button-compact-height": "2rem",
	"--textarea-button-compact-icon-size": "1.25rem",
	"--textarea-button-height": "2rem",
	"--textarea-button-icon-size": "1.375rem",
	"--textarea-container-padding-x": "0px",
	"--textarea-content-offset": "max(0rem, calc((2rem - calc(1rem * 1.375)) / 2))",
	"--textarea-font-size": "1rem",
	"--textarea-line-height": "calc(1rem * 1.375)",
	"--textarea-min-height": "3.625rem",
	"--textarea-padding-y": "max(0rem, calc((3.625rem - 2rem) / 2))",
	"--textarea-side-button-padding": "max( 0px, calc((2.5rem - 2rem) / 2) )",
	"--textarea-top-bar-height": "2.5rem",
	"--textarea-upload-gap": "0.75rem",
	"--theme-border": "transparent",
	"--theme-border-width": "0px",
	"--transition-fast": "100ms ease",
	"--transition-normal": "200ms ease",
	"--transition-slow": "300ms ease",
	"--typing-avatar-size": "0.75rem",
	"--typing-indicator-animation-size": "1rem",
	"--typing-indicator-gap": "0px",
	"--typing-indicator-height": "1rem",
	"--typing-pill-height": "1rem",
	"--user-area-avatar-lead": "max( 0.5rem, calc(4.5rem / 2 - 0.375rem - 2rem / 2) )",
	"--user-area-box-inset-block-end": "calc(0.375rem + 0.0625rem)",
	"--user-area-content-height": "2rem",
	"--user-area-divider-color": "color-mix(in srgb, hsla(258, calc(10% * var(--saturation-factor)), 100%, 0.05) 70%, transparent)",
	"--user-area-padding-x": "0.5rem",
	"--user-area-padding-y": "max(0rem, calc((3.625rem - 2rem) / 2))",
	"--user-select": "auto",
	"--voice-connection-padding-x": "0.5rem",
	"--voice-connection-padding-y": "0.5rem",
	"--z-index-base": "0",
	"--z-index-contextmenu": "44000",
	"--z-index-elevated-1": "10",
	"--z-index-elevated-2": "20",
	"--z-index-elevated-3": "30",
	"--z-index-modal": "10000",
	"--z-index-modal-swap": "25000",
	"--z-index-overlay": "40000",
	"--z-index-popout": "15000",
	"--z-index-popout-above-swap": "30000",
	"--z-index-titlebar": "100000",
	"--z-index-toast": "50000",
	"--z-index-tooltip": "45000",
};

export const THEME_LIGHT_DEFAULT_VARIABLE_VALUES: Readonly<Record<string, string>> = {
	"--accent-danger": "hsl(359, calc(70% * var(--saturation-factor)), 50%)",
	"--accent-info": "hsl(198, calc(92% * var(--saturation-factor)), 45%)",
	"--accent-primary": "hsl(242, calc(70% * var(--saturation-factor)), 55%)",
	"--accent-purple": "hsl(278, calc(85% * var(--saturation-factor)), 65%)",
	"--accent-success": "hsl(152, calc(70% * var(--saturation-factor)), 40%)",
	"--accent-warning": "hsl(45, calc(90% * var(--saturation-factor)), 45%)",
	"--active-now-action-gap": "0.375rem",
	"--active-now-action-height": "2rem",
	"--active-now-action-padding-block": "0.3125rem",
	"--active-now-action-padding-inline": "0.625rem",
	"--active-now-action-radius": "0.5rem",
	"--active-now-card-gap": "0.75rem",
	"--active-now-card-padding-block": "0.75rem",
	"--active-now-card-padding-inline": "0.875rem",
	"--active-now-card-radius": "0.375rem",
	"--active-now-card-shadow": "0 0.375rem 1.125rem rgba(0, 0, 0, 0.08)",
	"--active-now-context-gap": "0.375rem",
	"--active-now-sidebar-content-gap": "0.5rem",
	"--active-now-sidebar-content-padding-block-end": "0.75rem",
	"--active-now-sidebar-content-padding-inline": "0.75rem",
	"--active-now-sidebar-header-padding-block-end": "0.75rem",
	"--active-now-sidebar-header-padding-block-start": "1rem",
	"--active-now-sidebar-header-padding-inline": "1rem",
	"--active-now-sidebar-width": "22rem",
	"--alert-caution-color": "hsl(358, calc(80% * var(--saturation-factor)), 50%)",
	"--alert-important-color": "hsl(278, calc(85% * var(--saturation-factor)), 50%)",
	"--alert-note-color": "hsl(198, calc(92% * var(--saturation-factor)), 45%)",
	"--alert-tip-color": "hsl(150, calc(80% * var(--saturation-factor)), 35%)",
	"--alert-warning-color": "hsl(45, calc(90% * var(--saturation-factor)), 45%)",
	"--ansi-bg-black": "color-mix(in srgb, hsl(0, 0%, 0%) 86%, color-mix(in srgb, hsl(220, calc(10% * var(--saturation-factor)), 98.5%) 88%, hsl(220, calc(10% * var(--saturation-factor)), 92.84%) 12%) 14%)",
	"--ansi-bg-blue": "color-mix(in srgb, hsl(211, calc(95% * var(--saturation-factor)), 33%) 86%, color-mix(in srgb, hsl(220, calc(10% * var(--saturation-factor)), 98.5%) 88%, hsl(220, calc(10% * var(--saturation-factor)), 92.84%) 12%) 14%)",
	"--ansi-bg-bright-black": "color-mix(in srgb, hsl(0, 0%, 40%) 88%, color-mix(in srgb, hsl(220, calc(10% * var(--saturation-factor)), 98.5%) 88%, hsl(220, calc(10% * var(--saturation-factor)), 92.84%) 12%) 12%)",
	"--ansi-bg-bright-blue": "color-mix(in srgb, hsl(211, calc(95% * var(--saturation-factor)), 33%) 88%, color-mix(in srgb, hsl(220, calc(10% * var(--saturation-factor)), 98.5%) 88%, hsl(220, calc(10% * var(--saturation-factor)), 92.84%) 12%) 12%)",
	"--ansi-bg-bright-cyan": "color-mix(in srgb, hsl(192, calc(95% * var(--saturation-factor)), 38%) 88%, color-mix(in srgb, hsl(220, calc(10% * var(--saturation-factor)), 98.5%) 88%, hsl(220, calc(10% * var(--saturation-factor)), 92.84%) 12%) 12%)",
	"--ansi-bg-bright-green": "color-mix(in srgb, hsl(120, calc(82% * var(--saturation-factor)), 44%) 88%, color-mix(in srgb, hsl(220, calc(10% * var(--saturation-factor)), 98.5%) 88%, hsl(220, calc(10% * var(--saturation-factor)), 92.84%) 12%) 12%)",
	"--ansi-bg-bright-magenta": "color-mix(in srgb, hsl(300, calc(95% * var(--saturation-factor)), 38%) 88%, color-mix(in srgb, hsl(220, calc(10% * var(--saturation-factor)), 98.5%) 88%, hsl(220, calc(10% * var(--saturation-factor)), 92.84%) 12%) 12%)",
	"--ansi-bg-bright-red": "color-mix(in srgb, hsl(0, calc(62% * var(--saturation-factor)), 50%) 88%, color-mix(in srgb, hsl(220, calc(10% * var(--saturation-factor)), 98.5%) 88%, hsl(220, calc(10% * var(--saturation-factor)), 92.84%) 12%) 12%)",
	"--ansi-bg-bright-white": "color-mix(in srgb, hsl(0, 0%, 90%) 90%, color-mix(in srgb, hsl(220, calc(10% * var(--saturation-factor)), 98.5%) 88%, hsl(220, calc(10% * var(--saturation-factor)), 92.84%) 12%) 10%)",
	"--ansi-bg-bright-yellow": "color-mix(in srgb, hsl(62, calc(100% * var(--saturation-factor)), 36%) 88%, color-mix(in srgb, hsl(220, calc(10% * var(--saturation-factor)), 98.5%) 88%, hsl(220, calc(10% * var(--saturation-factor)), 92.84%) 12%) 12%)",
	"--ansi-bg-cyan": "color-mix(in srgb, hsl(192, calc(95% * var(--saturation-factor)), 38%) 86%, color-mix(in srgb, hsl(220, calc(10% * var(--saturation-factor)), 98.5%) 88%, hsl(220, calc(10% * var(--saturation-factor)), 92.84%) 12%) 14%)",
	"--ansi-bg-green": "color-mix(in srgb, hsl(120, calc(100% * var(--saturation-factor)), 25%) 86%, color-mix(in srgb, hsl(220, calc(10% * var(--saturation-factor)), 98.5%) 88%, hsl(220, calc(10% * var(--saturation-factor)), 92.84%) 12%) 14%)",
	"--ansi-bg-magenta": "color-mix(in srgb, hsl(288, calc(100% * var(--saturation-factor)), 43%) 86%, color-mix(in srgb, hsl(220, calc(10% * var(--saturation-factor)), 98.5%) 88%, hsl(220, calc(10% * var(--saturation-factor)), 92.84%) 12%) 14%)",
	"--ansi-bg-red": "color-mix(in srgb, hsl(0, calc(62% * var(--saturation-factor)), 50%) 86%, color-mix(in srgb, hsl(220, calc(10% * var(--saturation-factor)), 98.5%) 88%, hsl(220, calc(10% * var(--saturation-factor)), 92.84%) 12%) 14%)",
	"--ansi-bg-white": "color-mix(in srgb, hsl(0, 0%, 90%) 86%, color-mix(in srgb, hsl(220, calc(10% * var(--saturation-factor)), 98.5%) 88%, hsl(220, calc(10% * var(--saturation-factor)), 92.84%) 12%) 14%)",
	"--ansi-bg-yellow": "color-mix(in srgb, hsl(37, calc(52% * var(--saturation-factor)), 31%) 86%, color-mix(in srgb, hsl(220, calc(10% * var(--saturation-factor)), 98.5%) 88%, hsl(220, calc(10% * var(--saturation-factor)), 92.84%) 12%) 14%)",
	"--ansi-fg-black": "hsl(220, calc(10% * var(--saturation-factor)), 15%)",
	"--ansi-fg-blue": "color-mix(in srgb, hsl(211, calc(95% * var(--saturation-factor)), 33%) 92%, color-mix(in srgb, hsl(220, calc(10% * var(--saturation-factor)), 33.78%) 72%, hsl(340, calc(50% * var(--saturation-factor)), 38%) 28%) 8%)",
	"--ansi-fg-bright-black": "color-mix(in srgb, hsl(0, 0%, 40%) 88%, hsl(220, calc(10% * var(--saturation-factor)), 47.76%) 12%)",
	"--ansi-fg-bright-blue": "color-mix(in srgb, hsl(211, calc(95% * var(--saturation-factor)), 33%) 92%, hsl(220, calc(10% * var(--saturation-factor)), 15%) 8%)",
	"--ansi-fg-bright-cyan": "color-mix(in srgb, hsl(192, calc(95% * var(--saturation-factor)), 38%) 92%, hsl(220, calc(10% * var(--saturation-factor)), 15%) 8%)",
	"--ansi-fg-bright-green": "color-mix(in srgb, hsl(120, calc(82% * var(--saturation-factor)), 44%) 90%, hsl(220, calc(10% * var(--saturation-factor)), 15%) 10%)",
	"--ansi-fg-bright-magenta": "color-mix(in srgb, hsl(300, calc(95% * var(--saturation-factor)), 38%) 92%, hsl(220, calc(10% * var(--saturation-factor)), 15%) 8%)",
	"--ansi-fg-bright-red": "color-mix(in srgb, hsl(0, calc(62% * var(--saturation-factor)), 50%) 92%, hsl(220, calc(10% * var(--saturation-factor)), 15%) 8%)",
	"--ansi-fg-bright-white": "color-mix(in srgb, hsl(0, 0%, 65%) 86%, hsl(220, calc(10% * var(--saturation-factor)), 15%) 14%)",
	"--ansi-fg-bright-yellow": "color-mix(in srgb, hsl(62, calc(100% * var(--saturation-factor)), 36%) 90%, hsl(220, calc(10% * var(--saturation-factor)), 15%) 10%)",
	"--ansi-fg-cyan": "color-mix(in srgb, hsl(192, calc(95% * var(--saturation-factor)), 38%) 92%, color-mix(in srgb, hsl(220, calc(10% * var(--saturation-factor)), 33.78%) 72%, hsl(340, calc(50% * var(--saturation-factor)), 38%) 28%) 8%)",
	"--ansi-fg-green": "color-mix(in srgb, hsl(120, calc(100% * var(--saturation-factor)), 25%) 92%, color-mix(in srgb, hsl(220, calc(10% * var(--saturation-factor)), 33.78%) 72%, hsl(340, calc(50% * var(--saturation-factor)), 38%) 28%) 8%)",
	"--ansi-fg-magenta": "color-mix(in srgb, hsl(288, calc(100% * var(--saturation-factor)), 43%) 92%, color-mix(in srgb, hsl(220, calc(10% * var(--saturation-factor)), 33.78%) 72%, hsl(340, calc(50% * var(--saturation-factor)), 38%) 28%) 8%)",
	"--ansi-fg-red": "color-mix(in srgb, hsl(0, calc(62% * var(--saturation-factor)), 50%) 92%, color-mix(in srgb, hsl(220, calc(10% * var(--saturation-factor)), 33.78%) 72%, hsl(340, calc(50% * var(--saturation-factor)), 38%) 28%) 8%)",
	"--ansi-fg-white": "color-mix(in srgb, hsl(0, 0%, 33%) 88%, hsl(220, calc(10% * var(--saturation-factor)), 33.78%) 12%)",
	"--ansi-fg-yellow": "color-mix(in srgb, hsl(37, calc(52% * var(--saturation-factor)), 31%) 92%, color-mix(in srgb, hsl(220, calc(10% * var(--saturation-factor)), 33.78%) 72%, hsl(340, calc(50% * var(--saturation-factor)), 38%) 28%) 8%)",
	"--ansi-inverse-bg": "color-mix(in srgb, hsl(220, calc(10% * var(--saturation-factor)), 33.78%) 72%, hsl(340, calc(50% * var(--saturation-factor)), 38%) 28%)",
	"--ansi-inverse-text": "color-mix(in srgb, hsl(220, calc(10% * var(--saturation-factor)), 98.5%) 88%, hsl(220, calc(10% * var(--saturation-factor)), 92.84%) 12%)",
	"--avatar-stack-extra-height": "0.375rem",
	"--background-channel-header": "hsl(220, calc(10% * var(--saturation-factor)), 89.13%)",
	"--background-header-primary": "hsl(220, calc(10% * var(--saturation-factor)), 86.18%)",
	"--background-header-primary-hover": "hsl(220, calc(10% * var(--saturation-factor)), 86%)",
	"--background-header-secondary": "hsl(220, calc(10% * var(--saturation-factor)), 86.5%)",
	"--background-modifier-accent": "hsla(220, calc(10% * var(--saturation-factor)), 40%, 0.22)",
	"--background-modifier-accent-focus": "hsla(220, calc(10% * var(--saturation-factor)), 40%, 0.32)",
	"--background-modifier-hover": "hsla(220, calc(10% * var(--saturation-factor)), 10%, 0.05)",
	"--background-modifier-selected": "hsla(220, calc(10% * var(--saturation-factor)), 10%, 0.1)",
	"--background-primary": "hsl(220, calc(10% * var(--saturation-factor)), 98.5%)",
	"--background-secondary": "hsl(220, calc(10% * var(--saturation-factor)), 92.84%)",
	"--background-secondary-alt": "hsl(220, calc(10% * var(--saturation-factor)), 90.96%)",
	"--background-secondary-lighter": "hsl(220, calc(10% * var(--saturation-factor)), 94.61%)",
	"--background-tertiary": "hsl(220, calc(10% * var(--saturation-factor)), 88.2%)",
	"--background-textarea": "hsl(220, calc(10% * var(--saturation-factor)), 95.68%)",
	"--bg-active": "hsla(220, calc(10% * var(--saturation-factor)), 10%, 0.1)",
	"--bg-blockquote": "hsl(220, calc(10% * var(--saturation-factor)), 90.96%)",
	"--bg-code": "color-mix(in srgb, hsl(220, calc(10% * var(--saturation-factor)), 90.96%) 92%, color-mix(in srgb, hsl(220, calc(10% * var(--saturation-factor)), 33.78%) 72%, hsl(340, calc(50% * var(--saturation-factor)), 38%) 28%) 8%)",
	"--bg-code-block": "color-mix(in srgb, hsl(220, calc(10% * var(--saturation-factor)), 98.5%) 88%, hsl(220, calc(10% * var(--saturation-factor)), 92.84%) 12%)",
	"--bg-hover": "hsla(220, calc(10% * var(--saturation-factor)), 10%, 0.05)",
	"--bg-primary": "hsl(220, calc(10% * var(--saturation-factor)), 98.5%)",
	"--bg-secondary": "hsl(220, calc(10% * var(--saturation-factor)), 92.84%)",
	"--bg-table-header": "hsl(220, calc(10% * var(--saturation-factor)), 88.2%)",
	"--bg-table-row-even": "hsl(220, calc(10% * var(--saturation-factor)), 92.84%)",
	"--bg-table-row-odd": "hsl(220, calc(10% * var(--saturation-factor)), 98.5%)",
	"--bg-tertiary": "hsl(220, calc(10% * var(--saturation-factor)), 88.2%)",
	"--border-color": "hsla(220, calc(10% * var(--saturation-factor)), 40%, 0.15)",
	"--border-color-focus": "hsla(210, calc(90% * var(--saturation-factor)), 50%, 0.4)",
	"--border-color-hover": "hsla(220, calc(10% * var(--saturation-factor)), 40%, 0.25)",
	"--brand-primary": "hsl(242, calc(70% * var(--saturation-factor)), 55%)",
	"--brand-primary-fill": "hsl(0, 0%, 100%)",
	"--brand-primary-foreground": "hsl(242, calc(70% * var(--saturation-factor)), 55%)",
	"--brand-primary-light": "hsl(242, calc(100% * var(--saturation-factor)), 84%)",
	"--brand-primary-light-fill": "hsl(0, 0%, 100%)",
	"--brand-primary-pressed": "color-mix(in srgb, hsl(242, calc(70% * var(--saturation-factor)), 55%) 90%, hsl(0, 0%, 0%))",
	"--brand-primary-shade": "hsl(0, 0%, 0%)",
	"--brand-secondary": "hsl(242, calc(60% * var(--saturation-factor)), 49%)",
	"--brand-tint": "color-mix(in srgb, var(--brand-primary) 12%, var(--background-primary) 88%)",
	"--brand-tint-border": "color-mix(in srgb, var(--brand-primary) 45%, transparent 55%)",
	"--brand-tint-hover": "color-mix(in srgb, var(--brand-primary) 18%, var(--background-primary) 82%)",
	"--button-danger-active-fill": "hsl(359, calc(65% * var(--saturation-factor)), 45%)",
	"--button-danger-fill": "hsl(359, calc(70% * var(--saturation-factor)), 54%)",
	"--button-danger-outline-active-border": "transparent",
	"--button-danger-outline-active-fill": "hsl(359, calc(70% * var(--saturation-factor)), 50%)",
	"--button-danger-outline-border": "1px solid hsl(359, calc(70% * var(--saturation-factor)), 50%)",
	"--button-danger-outline-text": "hsl(359, calc(70% * var(--saturation-factor)), 45%)",
	"--button-danger-text": "hsl(0, 0%, 100%)",
	"--button-ghost-text": "hsl(220, calc(10% * var(--saturation-factor)), 20%)",
	"--button-inverted-fill": "hsl(0, 0%, 100%)",
	"--button-inverted-text": "hsl(0, 0%, 10%)",
	"--button-outline-active-border": "1px solid hsla(220, calc(10% * var(--saturation-factor)), 40%, 0.5)",
	"--button-outline-active-fill": "hsla(220, calc(10% * var(--saturation-factor)), 10%, 0.1)",
	"--button-outline-border": "1px solid hsla(220, calc(10% * var(--saturation-factor)), 40%, 0.3)",
	"--button-outline-text": "hsl(220, calc(10% * var(--saturation-factor)), 20%)",
	"--button-primary-active-fill": "hsl(136, calc(60% * var(--saturation-factor)), 38%)",
	"--button-primary-fill": "hsl(139, calc(55% * var(--saturation-factor)), 44%)",
	"--button-primary-text": "hsl(0, 0%, 100%)",
	"--button-secondary-active-fill": "hsla(220, calc(10% * var(--saturation-factor)), 10%, 0.15)",
	"--button-secondary-active-text": "hsl(220, calc(10% * var(--saturation-factor)), 10%)",
	"--button-secondary-fill": "hsla(220, calc(10% * var(--saturation-factor)), 10%, 0.1)",
	"--button-secondary-text": "hsl(220, calc(10% * var(--saturation-factor)), 15%)",
	"--channel-header-action-icon-size": "1.5rem",
	"--channel-header-action-size": "2rem",
	"--channel-header-action-size-mobile": "2.5rem",
	"--channel-header-actions-gap": "0.5rem",
	"--channel-header-back-button-gap": "0.75rem",
	"--channel-header-back-button-size": "2rem",
	"--channel-header-back-icon-size": "1.5rem",
	"--channel-header-caret-gap": "0.25rem",
	"--channel-header-caret-size": "1rem",
	"--channel-header-gap": "1rem",
	"--channel-header-icon-size": "1.5rem",
	"--channel-header-name-gap": "0.75rem",
	"--channel-header-name-gap-group-dm": "0.5rem",
	"--channel-header-padding-inline": "1rem",
	"--channel-header-topic-divider-gap": "0.5rem",
	"--chat-horizontal-padding": "1rem",
	"--chat-horizontal-padding-default": "1rem",
	"--chat-mobile-horizontal-padding": "0.75rem",
	"--code-block-bg": "color-mix(in srgb, hsl(220, calc(10% * var(--saturation-factor)), 98.5%) 88%, hsl(220, calc(10% * var(--saturation-factor)), 92.84%) 12%)",
	"--code-block-border": "color-mix(in srgb, hsla(220, calc(10% * var(--saturation-factor)), 40%, 0.15) 92%, color-mix(in srgb, hsl(220, calc(10% * var(--saturation-factor)), 33.78%) 72%, hsl(340, calc(50% * var(--saturation-factor)), 38%) 28%) 8%)",
	"--code-block-highlight": "color-mix(in srgb, hsl(0, 0%, 100%) 82%, transparent)",
	"--code-inline-bg": "color-mix(in srgb, hsl(220, calc(10% * var(--saturation-factor)), 90.96%) 92%, color-mix(in srgb, hsl(220, calc(10% * var(--saturation-factor)), 33.78%) 72%, hsl(340, calc(50% * var(--saturation-factor)), 38%) 28%) 8%)",
	"--code-muted": "color-mix(in srgb, color-mix(in srgb, hsl(220, calc(10% * var(--saturation-factor)), 33.78%) 72%, hsl(340, calc(50% * var(--saturation-factor)), 38%) 28%) 34%, hsl(220, calc(10% * var(--saturation-factor)), 47.76%) 66%)",
	"--code-text": "color-mix(in srgb, hsl(220, calc(10% * var(--saturation-factor)), 33.78%) 72%, hsl(340, calc(50% * var(--saturation-factor)), 38%) 28%)",
	"--composer-action-gap": "0.25rem",
	"--composer-box-inset": "max(0rem, calc((calc(3.625rem + 0.375rem * 2) - 3.625rem) / 2))",
	"--composer-box-inset-inline": "min( 0.375rem, 1rem )",
	"--composer-box-padding-inline": "max( 0rem, calc(1rem - min( 0.375rem, 1rem )) )",
	"--composer-mobile-box-height": "3rem",
	"--composer-mobile-padding-y": "max( 0rem, calc((3rem - 2rem) / 2) )",
	"--composer-status-line-height": "1.125rem",
	"--composer-status-row-height": "1.5rem",
	"--composer-status-safe-area": "calc(1.5rem + 0.5rem)",
	"--composer-status-safe-gap": "0.5rem",
	"--composer-surface-color": "hsl(220, calc(10% * var(--saturation-factor)), 94.61%)",
	"--content-padding": "1rem",
	"--content-padding-lg": "1.5rem",
	"--content-padding-sm": "0.75rem",
	"--control-button-active-bg": "hsl(220, calc(10% * var(--saturation-factor)), 85%)",
	"--control-button-active-text": "hsl(220, calc(10% * var(--saturation-factor)), 15%)",
	"--control-button-danger-hover-bg": "hsl(359, calc(70% * var(--saturation-factor)), 95%)",
	"--control-button-danger-text": "hsl(359, calc(70% * var(--saturation-factor)), 50%)",
	"--control-button-hover-bg": "hsl(220, calc(10% * var(--saturation-factor)), 88%)",
	"--control-button-hover-text": "hsl(220, calc(10% * var(--saturation-factor)), 20%)",
	"--control-button-normal-bg": "transparent",
	"--control-button-normal-text": "hsl(220, calc(10% * var(--saturation-factor)), 50%)",
	"--count-indicator-gap": "0.25rem",
	"--discovery-card-description-min-height": "5.25rem",
	"--dm-sidebar-mobile-header-height": "3.5rem",
	"--emoji-size-emoji": "1.5em",
	"--emoji-size-jumbo-emoji": "3rem",
	"--floating-surface-ring-color": "color-mix(in srgb, hsla(220, calc(10% * var(--saturation-factor)), 40%, 0.22) 20%, transparent)",
	"--floating-surface-ring-color-strong": "color-mix(in srgb, hsla(220, calc(10% * var(--saturation-factor)), 40%, 0.22) 45%, transparent)",
	"--focus-primary": "#00b0f4",
	"--folder-radius": "calc(3rem * 0.3)",
	"--font-fallback-mono": "'Noto Sans Mono', 'Fluxer Sans SC', 'Fluxer Sans TC', 'Fluxer Sans JP', 'Fluxer Sans KR', 'Apple Color Emoji', 'Segoe UI Emoji', 'Noto Color Emoji', 'Fluxer Fallback', 'Fluxer Symbols', 'Fluxer Math', 'Noto Sans', 'Nirmala UI', 'Noto Sans Bengali', 'Noto Sans Tamil', 'Noto Sans Telugu', 'Noto Sans Kannada', 'Noto Sans Malayalam', 'Noto Sans Gujarati', 'Noto Sans Gurmukhi', 'Noto Sans Oriya', 'Noto Sans Sinhala', 'Noto Sans Khmer', 'Noto Sans Lao', 'Noto Sans Myanmar', 'Noto Sans Tibetan', 'Noto Sans Armenian', 'Noto Sans Georgian', 'Noto Sans Ethiopic', 'Noto Sans Cherokee', 'Noto Sans Canadian Aboriginal', 'Noto Sans Mongolian', 'Noto Sans Vai', 'Noto Sans NKo', 'Noto Sans Adlam', 'Noto Sans Yi', 'Noto Sans Osage', 'Noto Sans Thaana', 'Noto Sans CJK SC', 'Noto Sans CJK TC', 'Noto Sans CJK JP', 'Noto Sans CJK KR', 'Segoe UI Symbol', 'Segoe UI Historic', 'Apple Symbols', 'Noto Sans Symbols', 'Noto Sans Symbols 2', 'Noto Sans Math', 'Cambria Math'",
	"--font-fallback-sans": "'Apple Color Emoji', 'Segoe UI Emoji', 'Noto Color Emoji', 'Fluxer Fallback', 'Fluxer Symbols', 'Fluxer Math', 'Noto Sans', 'Nirmala UI', 'Noto Sans Bengali', 'Noto Sans Tamil', 'Noto Sans Telugu', 'Noto Sans Kannada', 'Noto Sans Malayalam', 'Noto Sans Gujarati', 'Noto Sans Gurmukhi', 'Noto Sans Oriya', 'Noto Sans Sinhala', 'Noto Sans Khmer', 'Noto Sans Lao', 'Noto Sans Myanmar', 'Noto Sans Tibetan', 'Noto Sans Armenian', 'Noto Sans Georgian', 'Noto Sans Ethiopic', 'Noto Sans Cherokee', 'Noto Sans Canadian Aboriginal', 'Noto Sans Mongolian', 'Noto Sans Vai', 'Noto Sans NKo', 'Noto Sans Adlam', 'Noto Sans Yi', 'Noto Sans Osage', 'Noto Sans Thaana', 'Noto Sans CJK SC', 'Noto Sans CJK TC', 'Noto Sans CJK JP', 'Noto Sans CJK KR', 'Segoe UI Symbol', 'Segoe UI Historic', 'Apple Symbols', 'Noto Sans Symbols', 'Noto Sans Symbols 2', 'Noto Sans Math', 'Cambria Math'",
	"--font-keybind": "-apple-system, BlinkMacSystemFont, 'Fluxer Sans', 'Fluxer Sans Arabic', 'Fluxer Sans Hebrew', 'Fluxer Sans Devanagari', 'Fluxer Sans Thai Looped', 'Fluxer Sans SC', 'Fluxer Sans TC', 'Fluxer Sans JP', 'Fluxer Sans KR', system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Apple Color Emoji', 'Segoe UI Emoji', 'Noto Color Emoji', 'Fluxer Fallback', 'Fluxer Symbols', 'Fluxer Math', 'Noto Sans', 'Nirmala UI', 'Noto Sans Bengali', 'Noto Sans Tamil', 'Noto Sans Telugu', 'Noto Sans Kannada', 'Noto Sans Malayalam', 'Noto Sans Gujarati', 'Noto Sans Gurmukhi', 'Noto Sans Oriya', 'Noto Sans Sinhala', 'Noto Sans Khmer', 'Noto Sans Lao', 'Noto Sans Myanmar', 'Noto Sans Tibetan', 'Noto Sans Armenian', 'Noto Sans Georgian', 'Noto Sans Ethiopic', 'Noto Sans Cherokee', 'Noto Sans Canadian Aboriginal', 'Noto Sans Mongolian', 'Noto Sans Vai', 'Noto Sans NKo', 'Noto Sans Adlam', 'Noto Sans Yi', 'Noto Sans Osage', 'Noto Sans Thaana', 'Noto Sans CJK SC', 'Noto Sans CJK TC', 'Noto Sans CJK JP', 'Noto Sans CJK KR', 'Segoe UI Symbol', 'Segoe UI Historic', 'Apple Symbols', 'Noto Sans Symbols', 'Noto Sans Symbols 2', 'Noto Sans Math', 'Cambria Math', sans-serif",
	"--font-mono": "'Fluxer Mono', 'Menlo', 'Monaco', 'Courier New', 'Noto Sans Mono', 'Fluxer Sans SC', 'Fluxer Sans TC', 'Fluxer Sans JP', 'Fluxer Sans KR', 'Apple Color Emoji', 'Segoe UI Emoji', 'Noto Color Emoji', 'Fluxer Fallback', 'Fluxer Symbols', 'Fluxer Math', 'Noto Sans', 'Nirmala UI', 'Noto Sans Bengali', 'Noto Sans Tamil', 'Noto Sans Telugu', 'Noto Sans Kannada', 'Noto Sans Malayalam', 'Noto Sans Gujarati', 'Noto Sans Gurmukhi', 'Noto Sans Oriya', 'Noto Sans Sinhala', 'Noto Sans Khmer', 'Noto Sans Lao', 'Noto Sans Myanmar', 'Noto Sans Tibetan', 'Noto Sans Armenian', 'Noto Sans Georgian', 'Noto Sans Ethiopic', 'Noto Sans Cherokee', 'Noto Sans Canadian Aboriginal', 'Noto Sans Mongolian', 'Noto Sans Vai', 'Noto Sans NKo', 'Noto Sans Adlam', 'Noto Sans Yi', 'Noto Sans Osage', 'Noto Sans Thaana', 'Noto Sans CJK SC', 'Noto Sans CJK TC', 'Noto Sans CJK JP', 'Noto Sans CJK KR', 'Segoe UI Symbol', 'Segoe UI Historic', 'Apple Symbols', 'Noto Sans Symbols', 'Noto Sans Symbols 2', 'Noto Sans Math', 'Cambria Math', monospace",
	"--font-sans": "'Fluxer Sans', 'Fluxer Sans Arabic', 'Fluxer Sans Hebrew', 'Fluxer Sans Devanagari', 'Fluxer Sans Thai Looped', 'Fluxer Sans SC', 'Fluxer Sans TC', 'Fluxer Sans JP', 'Fluxer Sans KR', system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Apple Color Emoji', 'Segoe UI Emoji', 'Noto Color Emoji', 'Fluxer Fallback', 'Fluxer Symbols', 'Fluxer Math', 'Noto Sans', 'Nirmala UI', 'Noto Sans Bengali', 'Noto Sans Tamil', 'Noto Sans Telugu', 'Noto Sans Kannada', 'Noto Sans Malayalam', 'Noto Sans Gujarati', 'Noto Sans Gurmukhi', 'Noto Sans Oriya', 'Noto Sans Sinhala', 'Noto Sans Khmer', 'Noto Sans Lao', 'Noto Sans Myanmar', 'Noto Sans Tibetan', 'Noto Sans Armenian', 'Noto Sans Georgian', 'Noto Sans Ethiopic', 'Noto Sans Cherokee', 'Noto Sans Canadian Aboriginal', 'Noto Sans Mongolian', 'Noto Sans Vai', 'Noto Sans NKo', 'Noto Sans Adlam', 'Noto Sans Yi', 'Noto Sans Osage', 'Noto Sans Thaana', 'Noto Sans CJK SC', 'Noto Sans CJK TC', 'Noto Sans CJK JP', 'Noto Sans CJK KR', 'Segoe UI Symbol', 'Segoe UI Historic', 'Apple Symbols', 'Noto Sans Symbols', 'Noto Sans Symbols 2', 'Noto Sans Math', 'Cambria Math', sans-serif",
	"--font-sans-primary": "'Fluxer Sans'",
	"--font-size": "1rem",
	"--font-size-xs": "0.75rem",
	"--footer-box-height": "3.625rem",
	"--footer-box-inner-inset": "0.5rem",
	"--footer-box-inset": "0.375rem",
	"--footer-box-inset-inline": "0.375rem",
	"--footer-box-padding-y": "max(0rem, calc((3.625rem - 2rem) / 2))",
	"--footer-box-radius": "0.5rem",
	"--footer-row-height": "calc(3.625rem + 0.375rem * 2)",
	"--form-surface-background": "hsl(220, calc(10% * var(--saturation-factor)), 98.5%)",
	"--friend-row-action-gap": "0.5rem",
	"--friend-row-action-size": "2.25rem",
	"--friend-row-avatar-size": "2.25rem",
	"--friend-row-content-gap": "0.75rem",
	"--friend-row-name-line-height": "1.25rem",
	"--friend-row-padding-block": "0.75rem",
	"--friend-row-padding-inline": "1rem",
	"--friend-row-separator-inset": "0 0.4rem 0 0.5rem",
	"--friend-row-separator-radius": "0.375rem",
	"--friend-row-subtext-line-height": "1rem",
	"--friend-row-subtext-offset": "-0.0625rem",
	"--guild-badge-surface": "hsl(220, calc(10% * var(--saturation-factor)), 92.84%)",
	"--guild-folder-expanded-surface-size": "3rem",
	"--guild-icon-gap": "0.5rem",
	"--guild-icon-size": "2.75rem",
	"--guild-list-divider-base-gap": "0.375rem",
	"--guild-list-divider-line-size": "0.125rem",
	"--guild-list-foreground": "hsl(220, calc(10% * var(--saturation-factor)), 87.53%)",
	"--guild-list-indicator-bar-width": "0.35rem",
	"--guild-list-indicator-inset": "-0.15rem",
	"--guild-list-indicator-track-width": "0.5rem",
	"--guild-list-item-box-size": "3rem",
	"--guild-list-item-gap": "0.375rem",
	"--guild-list-item-target-half-extra": "calc((calc(3rem + 0.375rem) - 3rem) / 2)",
	"--guild-list-item-target-size": "calc(3rem + 0.375rem)",
	"--guild-members-columns": "minmax(15rem, 2.2fr) minmax(7.5rem, 1fr) minmax(7.5rem, 1fr) minmax(9.375rem, 1.15fr) minmax(10rem, 1.35fr) 4.5rem",
	"--guild-members-columns-selectable": "2.75rem minmax(15rem, 2.2fr) minmax(7.5rem, 1fr) minmax(7.5rem, 1fr) minmax(9.375rem, 1.15fr) minmax(10rem, 1.35fr) 4.5rem",
	"--guild-members-min-width": "calc(15rem + 7.5rem + 7.5rem + 9.375rem + 10rem + 4.5rem)",
	"--guild-members-min-width-selectable": "calc(2.75rem + calc(15rem + 7.5rem + 7.5rem + 9.375rem + 10rem + 4.5rem))",
	"--guild-members-select-column-width": "2.75rem",
	"--guild-members-table-row-border-width": "0.0625rem",
	"--guild-members-table-row-min-height": "3rem",
	"--guilds-layout-item-bg": "color-mix(in srgb, hsl(220, calc(10% * var(--saturation-factor)), 87.53%) 72%, hsl(220, calc(10% * var(--saturation-factor)), 98.5%) 28%)",
	"--input-container-min-height": "calc(3.625rem + 0.375rem * 2)",
	"--input-container-padding": "0.625rem",
	"--input-wrapper-padding-bottom": "0.5rem",
	"--input-wrapper-padding-x": "0.5rem",
	"--interactive-active": "color-mix( in oklab, hsl(0, calc(0% * var(--saturation-factor)), 100%) 100%, hsl(245, calc(100% * var(--saturation-factor)), 80%) 40% )",
	"--interactive-muted": "color-mix( in oklab, hsl(228, calc(10% * var(--saturation-factor)), 35%) 100%, hsl(245, calc(100% * var(--saturation-factor)), 80%) 40% )",
	"--invite-verified-icon-color": "hsl(242, calc(70% * var(--saturation-factor)), 55%)",
	"--layout-gap": "1rem",
	"--layout-gap-lg": "1.5rem",
	"--layout-gap-sm": "0.5rem",
	"--layout-guild-list-width": "4.5rem",
	"--layout-header-height": "3.5rem",
	"--layout-header-height-mobile": "4rem",
	"--layout-header-popout-width": "calc(20rem - (1rem * 2))",
	"--layout-member-list-width": "16.5rem",
	"--layout-mobile-bottom-nav-reserved-height": "0px",
	"--layout-sidebar-width": "20rem",
	"--layout-user-area-height": "3.625rem",
	"--layout-user-area-reserved-height": "0px",
	"--layout-voice-connection-height": "0px",
	"--link-decoration": "none",
	"--list-row-min-height": "4.5rem",
	"--macos-traffic-light-inset": "78px",
	"--markup-everyone-border": "hsla(250, calc(70% * var(--saturation-factor)), 45%, 0.4)",
	"--markup-everyone-fill": "color-mix(in srgb, hsl(250, calc(70% * var(--saturation-factor)), 45%) 12%, transparent)",
	"--markup-everyone-text": "hsl(250, calc(70% * var(--saturation-factor)), 45%)",
	"--markup-here-border": "hsla(40, calc(85% * var(--saturation-factor)), 40%, 0.4)",
	"--markup-here-fill": "color-mix(in srgb, hsl(40, calc(85% * var(--saturation-factor)), 40%) 12%, transparent)",
	"--markup-here-text": "hsl(40, calc(85% * var(--saturation-factor)), 40%)",
	"--markup-interactive-hover-fill": "color-mix(in srgb, hsl(198, calc(92% * var(--saturation-factor)), 45%) 30%, transparent)",
	"--markup-interactive-hover-text": "hsl(198, calc(92% * var(--saturation-factor)), 45%)",
	"--markup-jump-link-fill": "color-mix(in srgb, hsl(198, calc(92% * var(--saturation-factor)), 45%) 8%, transparent)",
	"--markup-jump-link-hover-fill": "color-mix(in srgb, hsl(198, calc(92% * var(--saturation-factor)), 45%) 20%, transparent)",
	"--markup-jump-link-text": "hsl(198, calc(92% * var(--saturation-factor)), 45%)",
	"--markup-mention-border": "hsla(198, calc(92% * var(--saturation-factor)), 45%, 0.4)",
	"--markup-mention-fill": "color-mix(in srgb, hsl(198, calc(92% * var(--saturation-factor)), 45%) 20%, transparent)",
	"--markup-mention-text": "hsl(198, calc(92% * var(--saturation-factor)), 45%)",
	"--markup-restricted-inline-emoji-baseline-shift": "-0.18em",
	"--markup-restricted-inline-emoji-size": "1.25em",
	"--markup-restricted-inline-icon-baseline-shift": "-0.125em",
	"--markup-strikethrough-color": "currentColor",
	"--media-border-radius": "0.25rem",
	"--member-list-group-spacer-height": "0.25rem",
	"--member-list-item-content-gap": "0.625rem",
	"--member-list-item-content-height": "2rem",
	"--member-list-item-name-line-height": "1.25rem",
	"--member-list-item-padding-block": "0.25rem",
	"--member-list-item-padding-inline": "0.5rem",
	"--member-list-item-status-line-height": "0.875rem",
	"--member-list-row-gap": "0.125rem",
	"--member-list-scroller-padding-block-end": "1rem",
	"--member-list-scroller-padding-block-start": "0.25rem",
	"--member-list-scroller-padding-inline": "0.5rem",
	"--mention-badge-medium-size": "1.5rem",
	"--mention-badge-small-size": "1.25rem",
	"--message-action-bar-offset": "3rem",
	"--message-avatar-align-offset": "clamp(0px, calc((1.375rem * 2 - 2.5rem) / 2), 0.5rem)",
	"--message-avatar-size": "2.5rem",
	"--message-avatar-size-compact": "1rem",
	"--message-compact-container-margin": "calc(3.5rem + 0.25rem)",
	"--message-compact-gap": "0.25rem",
	"--message-compact-horizontal-padding": "min( 1rem, 1rem )",
	"--message-compact-indent": "calc(3.5rem + 0.25rem)",
	"--message-compact-markdown-alert-padding-block": "0.35rem",
	"--message-compact-markdown-alert-padding-inline": "0.75rem",
	"--message-compact-markdown-block-gap": "0.5rem",
	"--message-compact-markdown-blockquote-divider-margin-end": "0.35rem",
	"--message-compact-markdown-blockquote-gap": "0.25rem",
	"--message-compact-table-max-inline-size": "100%",
	"--message-compact-table-min-cell-width": "5rem",
	"--message-compact-text-indent-from-username": "2rem",
	"--message-compact-timestamp-width": "3.5rem",
	"--message-compact-username-gap": "0.45rem",
	"--message-container-gap": "0.25rem",
	"--message-container-padding-y": "0.125rem",
	"--message-edited-font-size": "0.75rem",
	"--message-edited-label-font-size": "0.625rem",
	"--message-failed-indicator-font-size": "0.75rem",
	"--message-failed-indicator-gap": "0.375rem",
	"--message-failed-opacity": "0.5",
	"--message-filler-padding-bottom": "0.75rem",
	"--message-group-spacing": "1rem",
	"--message-gutter": "0.75rem",
	"--message-highlight-bar-width": "0.125rem",
	"--message-icon-size-lg": "1.25rem",
	"--message-icon-size-md": "1rem",
	"--message-icon-size-sm": "0.875rem",
	"--message-line-height": "1.375rem",
	"--message-mention-bg": "rgb(234 197 50 / 0.1)",
	"--message-mention-bg-hover": "rgb(234 197 50 / 0.14)",
	"--message-mention-color": "rgb(234 197 50)",
	"--message-mobile-margin": "0.75rem",
	"--message-preview-card-background": "hsl(0, 0%, 100%)",
	"--message-preview-card-border": "hsla(0, 0%, 0%, 0.07)",
	"--message-preview-card-divider": "hsla(0, 0%, 0%, 0.05)",
	"--message-replied-username-opacity": "0.64",
	"--message-reply-bg": "rgb(59 130 246 / 0.1)",
	"--message-reply-color": "rgb(59 130 246)",
	"--message-reply-font-size": "0.875rem",
	"--message-reply-height": "1.125rem",
	"--message-reply-spacing": "0.25rem",
	"--message-reply-spine-radius": "0.375rem",
	"--message-reply-spine-width": "0.125rem",
	"--message-search-bar-height": "2.25rem",
	"--message-search-bar-icon-gap": "0.5rem",
	"--message-search-bar-icon-size": "1rem",
	"--message-search-bar-width": "15.25rem",
	"--message-sending-link-opacity": "0.7",
	"--message-sending-opacity": "0.5",
	"--message-spacing-y": "0.125rem",
	"--message-timestamp-color": "hsl(220, calc(10% * var(--saturation-factor)), 42.2%)",
	"--message-timestamp-compact-font-size": "0.6875rem",
	"--message-timestamp-compact-height": "1.25rem",
	"--message-timestamp-font-size": "0.75rem",
	"--message-transition-highlight": "320ms cubic-bezier(0.32, 0.72, 0, 1)",
	"--message-typing-avatar-margin": "0.2rem",
	"--message-typing-gap": "0.35rem",
	"--message-typing-pill-gap": "0.2rem",
	"--message-typing-pill-padding": "0.45rem",
	"--message-typing-text-font-size": "0.6875rem",
	"--message-unknown-warning-color": "#ff9933",
	"--messages-bottom-clearance": "1.5rem",
	"--mobile-bottom-nav-height": "3.75rem",
	"--native-titlebar-height": "32px",
	"--outline-frame-border-width": "0.0625rem",
	"--outline-frame-radius-native": "clamp(0.5rem, 1.2vw, 0.875rem)",
	"--panel-control-bg": "color-mix(in srgb, hsl(220, calc(10% * var(--saturation-factor)), 92.84%) 65%, hsl(0, 0%, 100%) 35%)",
	"--panel-control-border": "hsla(220, calc(25% * var(--saturation-factor)), 45%, 0.25)",
	"--panel-control-divider": "hsla(220, calc(30% * var(--saturation-factor)), 35%, 0.2)",
	"--panel-control-highlight": "hsla(0, 0%, 100%, 0.65)",
	"--plutonium": "hsl(242, calc(70% * var(--saturation-factor)), 55%)",
	"--plutonium-hover": "hsl(242, calc(60% * var(--saturation-factor)), 49%)",
	"--plutonium-icon": "hsl(38, calc(92% * var(--saturation-factor)), 45%)",
	"--plutonium-text": "hsl(0, 0%, 98%)",
	"--radius-2xl": "1rem",
	"--radius-full": "624.9375rem",
	"--radius-lg": "0.5rem",
	"--radius-md": "0.375rem",
	"--radius-sm": "0.25rem",
	"--radius-xl": "0.75rem",
	"--saturation-factor": "1",
	"--scrollbar-thumb-bg": "color-mix(in srgb, hsl(220, calc(10% * var(--saturation-factor)), 86.5%) 40%, hsl(220, calc(10% * var(--saturation-factor)), 33.78%) 60%)",
	"--scrollbar-thumb-bg-hover": "color-mix(in srgb, hsl(220, calc(10% * var(--saturation-factor)), 86.5%) 30%, hsl(220, calc(10% * var(--saturation-factor)), 15%) 70%)",
	"--scrollbar-track-bg": "color-mix(in srgb, hsl(220, calc(10% * var(--saturation-factor)), 92.84%) 50%, transparent)",
	"--scroller-spacer-height": "1.75rem",
	"--shadow-lg": "0 4px 8px rgba(0, 0, 0, 0.15), 0 2px 4px rgba(0, 0, 0, 0.1)",
	"--shadow-md": "0 2px 4px rgba(0, 0, 0, 0.15), 0 1px 2px rgba(0, 0, 0, 0.1)",
	"--shadow-sm": "0 1px 2px rgba(0, 0, 0, 0.1)",
	"--shadow-xl": "0 10px 20px rgba(0, 0, 0, 0.15), 0 4px 8px rgba(0, 0, 0, 0.1)",
	"--skeleton-chrome-border": "0.0625rem solid color-mix(in srgb, hsla(220, calc(10% * var(--saturation-factor)), 40%, 0.22) 25%, transparent)",
	"--skeleton-chrome-border-color": "color-mix(in srgb, hsla(220, calc(10% * var(--saturation-factor)), 40%, 0.22) 25%, transparent)",
	"--skeleton-opacity-default": "0.45",
	"--skeleton-opacity-muted": "0.35",
	"--skeleton-opacity-strong": "0.55",
	"--slowmode-indicator-height": "1rem",
	"--spacing-0": "0px",
	"--spacing-1": "0.25rem",
	"--spacing-1-5": "0.375rem",
	"--spacing-10": "2.5rem",
	"--spacing-12": "3rem",
	"--spacing-16": "4rem",
	"--spacing-2": "0.5rem",
	"--spacing-20": "5rem",
	"--spacing-24": "6rem",
	"--spacing-3": "0.75rem",
	"--spacing-4": "1rem",
	"--spacing-5": "1.25rem",
	"--spacing-6": "1.5rem",
	"--spacing-8": "2rem",
	"--spoiler-border-radius": "0.375rem",
	"--spoiler-overlay-color": "rgba(0, 0, 0, 0.1)",
	"--spoiler-overlay-hover-color": "rgba(0, 0, 0, 0.15)",
	"--status-danger": "hsl(1, calc(77% * var(--saturation-factor)), 55%)",
	"--status-dnd": "hsl(359, calc(70% * var(--saturation-factor)), 50%)",
	"--status-idle": "hsl(45, calc(90% * var(--saturation-factor)), 45%)",
	"--status-offline": "hsl(210, calc(10% * var(--saturation-factor)), 55%)",
	"--status-online": "hsl(152, calc(70% * var(--saturation-factor)), 40%)",
	"--status-warning": "hsl(45, calc(90% * var(--saturation-factor)), 45%)",
	"--surface-interactive-hover-bg": "hsla(220, calc(10% * var(--saturation-factor)), 10%, 0.05)",
	"--surface-interactive-selected-bg": "hsla(220, calc(10% * var(--saturation-factor)), 10%, 0.1)",
	"--surface-interactive-selected-color": "hsl(220, calc(10% * var(--saturation-factor)), 15%)",
	"--system-message-icon-opacity": "0.6",
	"--system-message-icon-size": "1.125rem",
	"--text-chat": "hsl(220, calc(10% * var(--saturation-factor)), 20.99%)",
	"--text-chat-muted": "hsl(220, calc(10% * var(--saturation-factor)), 42.2%)",
	"--text-code": "color-mix(in srgb, hsl(220, calc(10% * var(--saturation-factor)), 33.78%) 72%, hsl(340, calc(50% * var(--saturation-factor)), 38%) 28%)",
	"--text-link": "hsl(198, calc(92% * var(--saturation-factor)), 45%)",
	"--text-on-brand-primary": "hsl(0, 0%, 98%)",
	"--text-on-brand-primary-light": "hsl(0, 0%, 98%)",
	"--text-on-brand-tint": "var(--brand-primary)",
	"--text-on-dark": "hsl(0, 0%, 98%)",
	"--text-primary": "hsl(220, calc(10% * var(--saturation-factor)), 15%)",
	"--text-primary-muted": "hsl(220, calc(10% * var(--saturation-factor)), 42.2%)",
	"--text-secondary": "hsl(220, calc(10% * var(--saturation-factor)), 33.78%)",
	"--text-selection": "hsla(210, calc(90% * var(--saturation-factor)), 50%, 0.2)",
	"--text-tertiary": "hsl(220, calc(10% * var(--saturation-factor)), 47.76%)",
	"--text-tertiary-muted": "hsl(220, calc(10% * var(--saturation-factor)), 53.12%)",
	"--text-tertiary-secondary": "hsl(220, calc(10% * var(--saturation-factor)), 51.56%)",
	"--text-warning": "hsl(45, calc(93% * var(--saturation-factor)), 55%)",
	"--textarea-button-compact-height": "2rem",
	"--textarea-button-compact-icon-size": "1.25rem",
	"--textarea-button-height": "2rem",
	"--textarea-button-icon-size": "1.375rem",
	"--textarea-container-padding-x": "0px",
	"--textarea-content-offset": "max(0rem, calc((2rem - calc(1rem * 1.375)) / 2))",
	"--textarea-font-size": "1rem",
	"--textarea-line-height": "calc(1rem * 1.375)",
	"--textarea-min-height": "3.625rem",
	"--textarea-padding-y": "max(0rem, calc((3.625rem - 2rem) / 2))",
	"--textarea-side-button-padding": "max( 0px, calc((2.5rem - 2rem) / 2) )",
	"--textarea-top-bar-height": "2.5rem",
	"--textarea-upload-gap": "0.75rem",
	"--theme-border": "transparent",
	"--theme-border-width": "0px",
	"--transition-fast": "100ms ease",
	"--transition-normal": "200ms ease",
	"--transition-slow": "300ms ease",
	"--typing-avatar-size": "0.75rem",
	"--typing-indicator-animation-size": "1rem",
	"--typing-indicator-gap": "0px",
	"--typing-indicator-height": "1rem",
	"--typing-pill-height": "1rem",
	"--user-area-avatar-lead": "max( 0.5rem, calc(4.5rem / 2 - 0.375rem - 2rem / 2) )",
	"--user-area-box-inset-block-end": "calc(0.375rem + 0.0625rem)",
	"--user-area-content-height": "2rem",
	"--user-area-divider-color": "hsla(220, calc(10% * var(--saturation-factor)), 40%, 0.2)",
	"--user-area-padding-x": "0.5rem",
	"--user-area-padding-y": "max(0rem, calc((3.625rem - 2rem) / 2))",
	"--user-select": "auto",
	"--voice-connection-padding-x": "0.5rem",
	"--voice-connection-padding-y": "0.5rem",
	"--z-index-base": "0",
	"--z-index-contextmenu": "44000",
	"--z-index-elevated-1": "10",
	"--z-index-elevated-2": "20",
	"--z-index-elevated-3": "30",
	"--z-index-modal": "10000",
	"--z-index-modal-swap": "25000",
	"--z-index-overlay": "40000",
	"--z-index-popout": "15000",
	"--z-index-popout-above-swap": "30000",
	"--z-index-titlebar": "100000",
	"--z-index-toast": "50000",
	"--z-index-tooltip": "45000",
};
